//const isSearchPath = window.location.pathname === "/search"; //this should be when use translation
const isSearchPath = !window.location.pathname.includes("/collections")
const pathname = window.location.pathname;
const segments = pathname.split('/');
let language = segments[1]; 
if (language.length > 2) {
  language = language.substring(0, 2); 
}
var listViewStat = false;
const debounceElastic = (fn, delay = 400) => {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => fn(...args), delay);
  };
};
function CurrencyFormatted(amount) {
  var i = parseFloat(amount);

  var minus = "";
  if (i < 0) {
    minus = "-";
  }
  i = Math.abs(i);
  i = parseInt((i + 0.005) * 100);
  i = i / 100;

  // Convert the number to a string
  var s = i.toString();

  // Split the string into integer and decimal parts
  var parts = s.split(".");
  var integerPart = parts[0];
  var decimalPart = parts[1]; // If no decimal part, assume '00'

  // Add commas as thousands separators to the integer part
  var formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Combine the formatted integer part and the decimal part
  if (decimalPart) {
    s = formattedInteger + "." + decimalPart;
  } else {
    s = formattedInteger;
  }

  s = minus + s;
  return s;
}

const InfinityElastic = async () => {
  const pathname = window.location.pathname;
  const segments = pathname.split('/');
  let language = segments[1]; 
  if (language.length > 2) {
    language = language.substring(0, 2); 
  }

  let options;
  let engineName;

  const baseOptions = {
    query: "",
    page: {
      size: 48,
      current: 1,
    },
    disjunctiveFacets: [
      "price",
      "condition",
      "vendor",
    ],
    filters: {
      all: [],
    },
    facets: {
      price: [
        {
          type: "range",
          name: "price",
          ranges: [
            { from: 25, to: 50 },
            { from: 50, to: 75 },
            { from: 75, to: 100 },
            { from: 100, to: 125 },
            { from: 125, to: 150 },
          ],
        },
      ],
      condition: [
        {
          type: "value",
          name: "condition",
          sort: {
            count: "desc",
          },
          size: 200,
        },
      ],
      vendor: [
        {
          type: "value",
          name: "vendor",
          sort: {
            count: "desc",
          },
          size: 200,
        },
      ],
    }
  };


  //get data from local engine
  if (language.startsWith("de")) {
    engineName = "abloom-ai-meta-total-german";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("ar")) {
    engineName = "abloom-ai-meta-total-arabic";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("ja")) {
    engineName = "abloom-ai-meta-total-japanese";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("it")) {
    engineName = "abloom-ai-meta-total-italian";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("fr")) {
    engineName = "abloom-ai-meta-total-french";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("es")) {
    engineName = "abloom-ai-meta-total-spanish";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("zh")) {
    engineName = "abloom-ai-meta-total-chinese";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("nl")) {
    engineName = "abloom-ai-meta-total-dutch";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("cz")) {
    engineName = "abloom-ai-meta-total-czech";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("da")) {
    engineName = "abloom-ai-meta-total-danish";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("el")) {
    engineName = "abloom-ai-meta-total-greek";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("kz")) {
    engineName = "abloom-ai-meta-total-kazakh";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("pt")) {
    engineName = "abloom-ai-meta-total-portuguese";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("ro")) {
    engineName = "abloom-ai-meta-total-romanian";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("sv")) {
    engineName = "abloom-ai-meta-total-swedish";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("th")) {
    engineName = "abloom-ai-meta-total-thai";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("vi")) {
    engineName = "abloom-ai-meta-total-vietnamese";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("fi")) {
    engineName = "abloom-ai-meta-total-finnish";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("no")) {
    engineName = "abloom-ai-meta-total-norwegian";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else if (language.startsWith("ko")) {
    engineName = "abloom-ai-meta-total-korean";
    options = JSON.parse(JSON.stringify(baseOptions));
  } else {
    engineName = "abloom-ai-meta-total";
    options = {
      query: "",
      page: {
        size: 48,
        current: 1,
      },
      disjunctiveFacets: [
        "price",
        "condition",
        "gift_type",
        "number_of_speakers",
        "number_of_hdmi_inputs",
        "frequency_band_type",
        "applicationusage",
        "number_of_output_devices_supported",
        "memory_technology",
        "integrated_processor_model",
        "graphics_controller_model",
        "raid_supported",
        "processor_generation_supported",
        "total_processor_supported",
        "multi_gpu_supported",
        "product_model",
        "hdmi",
        "environmental_certification",
        "intel_optane_memory_ready",
        "brand_name",
        "environmentally_friendly",
        "maximum_memory_supported",
        "product_line",
        "energy_star",
        "chipset_model",
        "memory_form_factor",
        "memory_speed_supported",
        "description",
        "created_at",
        "processor_supported",
        "controller_type",
        "vendor",
        "processor_socket",
        "memory_standard",
        "onboard_video",
        "integrated_processor_type",
        "integrated_processor_speed",
        "number_of_memory_slots",
        "limited_warranty",
        "integrated_processor_cache",
        "raid_levels",
        "total_variants",
        "product_type",
        "gigabit_ethernet",
        "product_series",
        "displayport",
        "integrated_processor_core",
        "form_factor",
        "parallel_port",
        "platform_supported",
        "cutter",
        "media_type",
        "standard_memory",
        "input_voltage",
        "wireless_lan_standard",
        "height",
        "touchscreen",
        "maximum_mono_print_speed_ppm",
        "print_color_capability",
        "processor_speed",
        "duplex_printing",
        "serial_port",
        "depth",
        "width",
        "maximum_color_print_speed",
        "connectivity_technology",
        "usb",
        "features",
        "first_print_speed",
        "screen_size",
        "maximum_print_width",
        "multifunction_devices",
        "product_color",
        "ethernet_technology",
        "printing_capability",
        "layer_thickness",
        "ethernet",
        "supported_material",
        "maximum_mono_print_speed",
        "virtual_assistant_supported",
        "maximum_print_speed",
        "wireless_lan",
        "print_technology",
        "filament_diameter",
        "maximum_color_print_speed_ppm",
        "power_source",
        "maximum_print_length",
        "recommended_use",
        "maximum_print_resolution_dpi",
        "product_condition",
        "length",
        "print_jet",
        "bluetooth",
        "iso_mono_print_speed_ipm",
        "operating_system_supported",
        "localization",
        "device_supported",
        "backlight_type",
        "pointing_device_type",
        "hot_keys",
        "keyboardkeypad_connectivity_technology",
        "keys_layout",
        "postconsumerwaste",
        "total_number_of_keys",
        "keyboardkeypad_host_interface",
        "number_of_batteries_supported",
        "keyboardkeypad_depth",
        "number_of_hot_keys",
        "additional_warranty_information",
        "assembly_required",
        "keyboardkeypad_wireless_technology",
        "bluetooth_version",
        "backlight",
        "taa_compliant",
        "keyboardkeypad_features",
        "number_of_keys",
        "number_of_programmable_keys",
        "key_layout",
        "keyboardkeypad_height",
        "keyboardkeypad_width",
        "operating_system_compatibility",
        "rugged",
        "battery_included",
        "keyswitch_technology",
        "keyboardkeypad_wireless_operating_distance",
        "battery_size_supported",
        "number_of_relegendable_keys",
        "wireless_operating_frequency",
        "product_material",
        "builtin_devices",
        "number_of_usb_ports",
        "number_of_hdmi_outputs",
        "number_of_vga_outputs",
        "sound_mode",
        "media_type_supported",
        "display_screen_type",
        "headphone",
        "input_device_type",
        "cellular_network_supported",
        "memory_card_supported",
        "processor_generation",
        "processor_model",
        "display_screen_technology",
        "solid_state_drive_capacity",
        "cellular_data_connectivity_technology",
        "service_provider",
        "screen_resolution",
        "cellular_phone_capability",
        "aspect_ratio",
        "processor_type",
        "input_resolution",
        "pressure_levels",
        "processor_core",
        "wwan_supported",
        "cellular_generation",
        "active_area",
        "flash_memory_capacity",
        "memory_card_supported_capacity",
        "screen_mode",
        "hdmi_out",
        "microphone",
        "vpro_technology",
        "solid_state_drive_interface",
        "memory_clock_speed",
        "optical_drive_type",
        "memory_configuration",
        "number_of_processors_supported",
        "total_hard_drive_capacity",
        "signal_processing",
        "error_checking",
        "number_of_processors_installed",
        "total_solid_state_drive_capacity",
        "number_of_total_memory_slots",
        "durability",
        "number_of_input_devices_supported",
        "maximum_video_resolution",
        "maximum_operating_distance",
        "graphics_modes",
        "tuner",
        "load_capacity",
        "plugconnector_type",
        "phase",
        "backuprun_time",
        "receptacle_detail",
        "output_voltage",
        "number_of_battery__surge_outlets",
        "transfer_time",
        "replaceable_battery",
        "receptacle_type",
        "rack_height",
        "display",
        "dataline_protection",
        "battery_capacity",
        "maximum_battery_life",
        "minimum_battery_life",
        "maximum_operating_elevation",
        "battery_characteristics",
        "battery_chemistry",
        "maximum_operating_temperature",
        "avr",
        "hot_swappable",
        "mount_type",
        "panel_technology",
        "backlight_technology",
        "camera_resolution",
        "tearing_prevention_technology",
        "dvi",
        "speakers",
        "standard_refresh_rate",
        "impact_protection_ik_rating",
        "offmode_power_consumption",
        "vr_ready",
        "usb_typec_front",
        "graphics_processor_core",
        "number_of_usb_32_gen_2_ports",
        "number_of_usb_20_ports",
        "number_of_usb_30_ports",
        "usb_typec",
        "intel_optane_memory_capacity",
        "usb_typec_detail",
        "graphics_memory_accessibility",
        "graphics_memory_technology",
        "ssd_form_factor",
        "total_number_of_usb_ports",
        "operating_system",
        "maximum_turbo_speed",
        "solid_state_drive_configuration",
        "hard_drive_configuration",
        "monitor_included",
        "lan_model",
        "remote_management",
        "redundant_power_supply",
        "number_of_total_expansion_bays",
        "number_of_hard_drives_installed",
        "network_standard",
        "maximum_power_supply_wattage",
        "number_of_power_supplies_installed",
        "number_of_power_supplies_supported",
        "number_of_35_bays",
        "number_of_hard_drives_supported",
        "total_hard_drive_capacity_supported",
        "expansion_slot_type",
        "number_of_broadband_rj45_ports",
        "carrier_supported",
        "powerline",
        "wifi_generation",
        "unii_maximum_frequency",
        "total_number_of_antennas",
        "poe_rj45_port",
        "number_of_total_expansion_slots",
        "management_port",
        "power_consumption",
        "unii_band",
        "number_of_wan_ports",
        "usb_standard",
        "ism_maximum_frequency",
        "number_of_internal_antennas",
        "broadband_transmission_technology",
        "total_number_of_ports",
        "compatible_rack_unit",
        "ism_band",
        "total_wireless_transmission_speed",
        "voip_supported",
        "sim_size_supported",
        "vpn_supported",
        "redundant_power_supply_supported",
        "license_type",
        "network_band",
        "network_technology",
        "networking_standards",
        "number_of_sim_card_supported",
        "number_of_external_antennas",
        "multisim_supported",
        "number_of_serial_ports",
        "vga",
        "total_hard_drive_capacity_installed",
        "number_of_usb_32_gen_1_ports",
        "operating_system_platform",
        "hybrid_hard_drive_capacity",
        "operation_hours",
        "screen_size_class",
        "native_contrast_ratio",
        "stand_adjustments",
        "number_of_displayports",
        "contrast_ratio",
        "placement",
        "vesa_mount_compatible",
        "hdcp_supported",
        "color",
        "thunderbolt",
        "curved_screen",
        "touchscreen_type",
        "viewable_screen_size",
        "adjustable_stand_height",
        "maximum_resolution",
        "ingress_protection_ip_rating",
        "color_supported",
        "multitouch_screen",
        "number_of_screens",
        "brightness",
        "horizontal_frequency",
        "vertical_frequency",
        "pixel_pitch",
        "dynamic_contrast_ratio",
        "operating_power_consumption",
        "response_time",
        "data_transfer_rate",
        "number_of_controllable_devices",
        "modular",
        "maximum_frequency",
        "number_of_fibre_channel_ports",
        "portexpansion_slot_details",
        "number_of_infiniband_ports",
        "dimmer_type",
        "current",
        "switch_type",
        "manageable",
        "current_rating",
        "controllable_function",
        "stack_port",
        "minimum_frequency",
        "uplink_port",
        "power_rating",
        "layer_supported",
        "maximum_data_transfer_rate",
        "protection_type",
        "receptacles",
        "total_number_of_network_ports",
        "storage_type",
        "maximum_focal_length",
        "recording_formats",
        "operating_humidity",
        "lens_type",
        "tilt",
        "night_vision_type",
        "hd_recording",
        "diameter",
        "video_signal_format",
        "minimum_operating_temperature",
        "effective_camera_resolution",
        "night_vision",
        "maximum_illumination",
        "impact_protection_rating",
        "horizontal_resolution",
        "lens_mount_type",
        "longest_shutter_speed",
        "optical_zoom",
        "minimum_focal_length",
        "image_sensor_size",
        "number_of_ir_leds",
        "night_vision_distance",
        "maximum_aperture",
        "image_sensor_type",
        "video_formats",
        "indooroutdoor",
        "shortest_shutter_speed",
        "minimum_aperture",
        "rms_output_power",
        "software_included",
        "touchscreen_technology",
        "ambient_light_sensor",
        "number_of_touch_points",
        "webcam",
        "tempered_glass",
        "scan_format",
        "accessibility",
        "style",
        "number_of_25_bays",
        "rdx_technology",
        "number_of_2535_bays",
        "number_of_solid_state_drive_installed",
        "number_of_external_525_bays",
        "case_capacity",
        "number_of_solid_state_drive_supported",
        "ssd_cache_capacity",
        "host_interface",
        "case_component",
        "noise_levels",
        "connectors",
        "fan_speed_min",
        "rated_current",
        "compatible_amd_socket",
        "maximum_fan_diameter",
        "heatsink_depth",
        "noise_levels_aweighted",
        "maximum_airflow",
        "number_of_fans",
        "heatsink_width",
        "radiator_material",
        "heatsink_height",
        "fan_life",
        "maximum_air_pressure",
        "fan_width",
        "led_color",
        "fan_depth",
        "fan_height",
        "compatible_intel_socket",
        "minimum_airflow",
        "minimum_fan_diameter",
        "cooler_type",
        "fan_bearing_type",
        "radiator_width",
        "fan_material",
        "fan_speed_max",
        "radiator_height",
        "heatsink_material",
        "memory_speed",
        "thickness",
        "memory_voltage",
        "number_of_modules",
        "memory_rank",
        "number_of_pins",
        "rgb",
        "cas_latency",
        "nonrgb",
        "memory_size",
        "mini_hdmi",
        "multigpu_technology",
        "mini_displayport",
        "number_of_gpus",
        "number_of_displayport_outputs",
        "chipset_series",
        "bus_width",
        "number_of_dvii_ports",
        "power_supply_wattage",
        "power_connector",
        "gpu_boost_clock",
        "gpu_clock",
        "number_of_mini_hdmi_outputs",
        "cuda_cores",
        "card_length",
        "host_interface_connector_type",
        "number_of_monitors_supported",
        "number_of_usb_typec_ports",
        "total_number_of_dvi_outputs",
        "maximum_digital_display_resolution",
        "number_of_dvid_ports",
        "dual_link_dvi_supported",
        "card_height",
        "game_clock",
        "api_supported",
        "chipset_line",
        "slot_space_required",
        "number_of_mini_displayport_outputs",
        "number_of_external_25_bays",
        "number_of_internal_2535_bays",
        "number_of_external_35_bays",
        "power_supply_installed",
        "number_of_fans_installed",
        "front_audio_in",
        "motherboard_supported",
        "maximum_psu_length",
        "number_of_internal_525_bays",
        "usb_port_details",
        "installed_fan_size",
        "total_number_of_audio_in_ports",
        "total_number_of_audio_out_ports",
        "front_audio_out",
        "front_usb",
        "number_of_internal_25_bays",
        "number_of_external_2535_bays",
        "number_of_fans_supported",
        "audio_line_out",
        "number_of_internal_35_bays",
        "maximum_cpu_cooler_height",
        "cable_length",
        "polar_pattern",
        "impedance",
        "microphone_technology",
        "microphone_sensitivity",
        "noise_canceling",
        "wireless_operating_distance",
        "microphone_type",
        "minimum_frequency_response",
        "plating",
        "microphone_controls",
        "maximum_frequency_response",
        "wireless_technology",
        "serial_in",
        "widescreen",
        "focus_modes",
        "digital_zoom",
        "serial_out",
        "face_tracking",
        "effective_resolution",
        "mounting_type",
        "interpolated_resolution",
        "maximum_frame_rate",
        "surface_material",
        "printed_designpatterntexture",
        "size",
        "filling_material",
        "combined_processor_core",
        "maximum_supported_system_memory",
        "intel_evo_platform",
        "release_month",
        "system_memory_technology",
        "installed_slot_memory_configuration",
        "total_number_of_memory_slots",
        "system_memory_speed",
        "optical_media_supported",
        "drive_type",
        "release_year",
        "onboard_memory",
        "system_memory_form_factor",
        "total_installed_system_memory",
        "onboard_memory_technology",
        "number_of_occupied_memory_slots",
        "builtin_outlet",
        "phone_line_rj11",
        "powerline_data_transfer_rate",
        "wireless_transmission_speed",
        "maximum_distance_supported",
        "area_coverage",
        "powerline_transmission_standard",
        "audio_line_in",
        "number_of_phone_line_rj11_ports",
        "modem_transmission_data_rate",
        "modulation",
        "broadband_transmission_speed",
        "number_of_modem_rj11_ports",
        "fax_transmission_data_rate",
        "fax_technology",
        "ftype",
      ],
      filters: {
        all: [],
      },
      facets: {
        // yotpo_reviews_average: [
        //   {
        //     type: "range",
        //     name: "yotpo_reviews_average",
        //     ranges: [{ from: 4 }, { from: 3 }, { from: 2 }, { from: 1 }],
        //   },
        // ],
        // sort_number: [
        //   {
        //     type: "value",
        //     name: "sort_number",
        //     sort: {
        //       count: "desc",
        //     },
        //     size: 200,
        //   },
        // ],
        condition: [
          {
            type: "value",
            name: "condition",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_speakers: [
          {
            type: "value",
            name: "number_of_speakers",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_hdmi_inputs: [
          {
            type: "value",
            name: "number_of_hdmi_inputs",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        frequency_band_type: [
          {
            type: "value",
            name: "frequency_band_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        applicationusage: [
          {
            type: "value",
            name: "applicationusage",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_output_devices_supported: [
          {
            type: "value",
            name: "number_of_output_devices_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        memory_technology: [
          {
            type: "value",
            name: "memory_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        integrated_processor_model: [
          {
            type: "value",
            name: "integrated_processor_model",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        graphics_controller_model: [
          {
            type: "value",
            name: "graphics_controller_model",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        raid_supported: [
          {
            type: "value",
            name: "raid_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        processor_generation_supported: [
          {
            type: "value",
            name: "processor_generation_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_processor_supported: [
          {
            type: "value",
            name: "total_processor_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        multi_gpu_supported: [
          {
            type: "value",
            name: "multi_gpu_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        product_model: [
          {
            type: "value",
            name: "product_model",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        hdmi: [
          {
            type: "value",
            name: "hdmi",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        environmental_certification: [
          {
            type: "value",
            name: "environmental_certification",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        intel_optane_memory_ready: [
          {
            type: "value",
            name: "intel_optane_memory_ready",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        environmentally_friendly: [
          {
            type: "value",
            name: "environmentally_friendly",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_memory_supported: [
          {
            type: "value",
            name: "maximum_memory_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        energy_star: [
          {
            type: "value",
            name: "energy_star",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        chipset_model: [
          {
            type: "value",
            name: "chipset_model",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        memory_form_factor: [
          {
            type: "value",
            name: "memory_form_factor",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_speed_supported: [
          {
            type: "value",
            name: "memory_speed_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        processor_supported: [
          {
            type: "value",
            name: "processor_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        controller_type: [
          {
            type: "value",
            name: "controller_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        vendor: [
          {
            type: "value",
            name: "vendor",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        processor_socket: [
          {
            type: "value",
            name: "processor_socket",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_standard: [
          {
            type: "value",
            name: "memory_standard",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        onboard_video: [
          {
            type: "value",
            name: "onboard_video",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        integrated_processor_type: [
          {
            type: "value",
            name: "integrated_processor_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        integrated_processor_speed: [
          {
            type: "value",
            name: "integrated_processor_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_memory_slots: [
          {
            type: "value",
            name: "number_of_memory_slots",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        limited_warranty: [
          {
            type: "value",
            name: "limited_warranty",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        integrated_processor_cache: [
          {
            type: "value",
            name: "integrated_processor_cache",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        raid_levels: [
          {
            type: "value",
            name: "raid_levels",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        product_type: [
          {
            type: "value",
            name: "product_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        gigabit_ethernet: [
          {
            type: "value",
            name: "gigabit_ethernet",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        product_series: [
          {
            type: "value",
            name: "product_series",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        displayport: [
          {
            type: "value",
            name: "displayport",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        integrated_processor_core: [
          {
            type: "value",
            name: "integrated_processor_core",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        form_factor: [
          {
            type: "value",
            name: "form_factor",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        parallel_port: [
          {
            type: "value",
            name: "parallel_port",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        platform_supported: [
          {
            type: "value",
            name: "platform_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        cutter: [
          {
            type: "value",
            name: "cutter",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        media_type: [
          {
            type: "value",
            name: "media_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        standard_memory: [
          {
            type: "value",
            name: "standard_memory",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        input_voltage: [
          {
            type: "value",
            name: "input_voltage",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        wireless_lan_standard: [
          {
            type: "value",
            name: "wireless_lan_standard",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        touchscreen: [
          {
            type: "value",
            name: "touchscreen",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        maximum_mono_print_speed_ppm: [
          {
            type: "value",
            name: "maximum_mono_print_speed_ppm",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        print_color_capability: [
          {
            type: "value",
            name: "print_color_capability",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        processor_speed: [
          {
            type: "value",
            name: "processor_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        duplex_printing: [
          {
            type: "value",
            name: "duplex_printing",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        serial_port: [
          {
            type: "value",
            name: "serial_port",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        maximum_color_print_speed: [
          {
            type: "value",
            name: "maximum_color_print_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        connectivity_technology: [
          {
            type: "value",
            name: "connectivity_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        usb: [
          {
            type: "value",
            name: "usb",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        features: [
          {
            type: "value",
            name: "features",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        first_print_speed: [
          {
            type: "value",
            name: "first_print_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        screen_size: [
          {
            type: "value",
            name: "screen_size",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_print_width: [
          {
            type: "value",
            name: "maximum_print_width",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        multifunction_devices: [
          {
            type: "value",
            name: "multifunction_devices",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        product_color: [
          {
            type: "value",
            name: "product_color",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        ethernet_technology: [
          {
            type: "value",
            name: "ethernet_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        printing_capability: [
          {
            type: "value",
            name: "printing_capability",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        layer_thickness: [
          {
            type: "value",
            name: "layer_thickness",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        ethernet: [
          {
            type: "value",
            name: "ethernet",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        supported_material: [
          {
            type: "value",
            name: "supported_material",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_mono_print_speed: [
          {
            type: "value",
            name: "maximum_mono_print_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        virtual_assistant_supported: [
          {
            type: "value",
            name: "virtual_assistant_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_print_speed: [
          {
            type: "value",
            name: "maximum_print_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        wireless_lan: [
          {
            type: "value",
            name: "wireless_lan",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        print_technology: [
          {
            type: "value",
            name: "print_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        filament_diameter: [
          {
            type: "value",
            name: "filament_diameter",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_color_print_speed_ppm: [
          {
            type: "value",
            name: "maximum_color_print_speed_ppm",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        power_source: [
          {
            type: "value",
            name: "power_source",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        maximum_print_length: [
          {
            type: "value",
            name: "maximum_print_length",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        recommended_use: [
          {
            type: "value",
            name: "recommended_use",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_print_resolution_dpi: [
          {
            type: "value",
            name: "maximum_print_resolution_dpi",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        length: [
          {
            type: "value",
            name: "length",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        print_jet: [
          {
            type: "value",
            name: "print_jet",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        bluetooth: [
          {
            type: "value",
            name: "bluetooth",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        iso_mono_print_speed_ipm: [
          {
            type: "value",
            name: "iso_mono_print_speed_ipm",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        operating_system_supported: [
          {
            type: "value",
            name: "operating_system_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        localization: [
          {
            type: "value",
            name: "localization",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        device_supported: [
          {
            type: "value",
            name: "device_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        backlight_type: [
          {
            type: "value",
            name: "backlight_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        pointing_device_type: [
          {
            type: "value",
            name: "pointing_device_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        hot_keys: [
          {
            type: "value",
            name: "hot_keys",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keyboardkeypad_connectivity_technology: [
          {
            type: "value",
            name: "keyboardkeypad_connectivity_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keys_layout: [
          {
            type: "value",
            name: "keys_layout",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        postconsumerwaste: [
          {
            type: "value",
            name: "postconsumerwaste",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_number_of_keys: [
          {
            type: "value",
            name: "total_number_of_keys",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keyboardkeypad_host_interface: [
          {
            type: "value",
            name: "keyboardkeypad_host_interface",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_batteries_supported: [
          {
            type: "value",
            name: "number_of_batteries_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keyboardkeypad_depth: [
          {
            type: "value",
            name: "keyboardkeypad_depth",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_hot_keys: [
          {
            type: "value",
            name: "number_of_hot_keys",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        additional_warranty_information: [
          {
            type: "value",
            name: "additional_warranty_information",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        assembly_required: [
          {
            type: "value",
            name: "assembly_required",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keyboardkeypad_wireless_technology: [
          {
            type: "value",
            name: "keyboardkeypad_wireless_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        bluetooth_version: [
          {
            type: "value",
            name: "bluetooth_version",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        backlight: [
          {
            type: "value",
            name: "backlight",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        taa_compliant: [
          {
            type: "value",
            name: "taa_compliant",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keyboardkeypad_features: [
          {
            type: "value",
            name: "keyboardkeypad_features",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_keys: [
          {
            type: "value",
            name: "number_of_keys",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_programmable_keys: [
          {
            type: "value",
            name: "number_of_programmable_keys",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        key_layout: [
          {
            type: "value",
            name: "key_layout",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keyboardkeypad_height: [
          {
            type: "value",
            name: "keyboardkeypad_height",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keyboardkeypad_width: [
          {
            type: "value",
            name: "keyboardkeypad_width",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        operating_system_compatibility: [
          {
            type: "value",
            name: "operating_system_compatibility",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        rugged: [
          {
            type: "value",
            name: "rugged",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        battery_included: [
          {
            type: "value",
            name: "battery_included",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keyswitch_technology: [
          {
            type: "value",
            name: "keyswitch_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        keyboardkeypad_wireless_operating_distance: [
          {
            type: "value",
            name: "keyboardkeypad_wireless_operating_distance",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        battery_size_supported: [
          {
            type: "value",
            name: "battery_size_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_relegendable_keys: [
          {
            type: "value",
            name: "number_of_relegendable_keys",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        wireless_operating_frequency: [
          {
            type: "value",
            name: "wireless_operating_frequency",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        product_material: [
          {
            type: "value",
            name: "product_material",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        builtin_devices: [
          {
            type: "value",
            name: "builtin_devices",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_usb_ports: [
          {
            type: "value",
            name: "number_of_usb_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_hdmi_outputs: [
          {
            type: "value",
            name: "number_of_hdmi_outputs",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_vga_outputs: [
          {
            type: "value",
            name: "number_of_vga_outputs",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        sound_mode: [
          {
            type: "value",
            name: "sound_mode",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        media_type_supported: [
          {
            type: "value",
            name: "media_type_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        display_screen_type: [
          {
            type: "value",
            name: "display_screen_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        headphone: [
          {
            type: "value",
            name: "headphone",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        input_device_type: [
          {
            type: "value",
            name: "input_device_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        cellular_network_supported: [
          {
            type: "value",
            name: "cellular_network_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_card_supported: [
          {
            type: "value",
            name: "memory_card_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        processor_generation: [
          {
            type: "value",
            name: "processor_generation",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        processor_model: [
          {
            type: "value",
            name: "processor_model",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        display_screen_technology: [
          {
            type: "value",
            name: "display_screen_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        solid_state_drive_capacity: [
          {
            type: "value",
            name: "solid_state_drive_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        cellular_data_connectivity_technology: [
          {
            type: "value",
            name: "cellular_data_connectivity_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        service_provider: [
          {
            type: "value",
            name: "service_provider",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        screen_resolution: [
          {
            type: "value",
            name: "screen_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        cellular_phone_capability: [
          {
            type: "value",
            name: "cellular_phone_capability",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        aspect_ratio: [
          {
            type: "value",
            name: "aspect_ratio",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        processor_type: [
          {
            type: "value",
            name: "processor_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        input_resolution: [
          {
            type: "value",
            name: "input_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        pressure_levels: [
          {
            type: "value",
            name: "pressure_levels",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        processor_core: [
          {
            type: "value",
            name: "processor_core",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        wwan_supported: [
          {
            type: "value",
            name: "wwan_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        cellular_generation: [
          {
            type: "value",
            name: "cellular_generation",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        active_area: [
          {
            type: "value",
            name: "active_area",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        flash_memory_capacity: [
          {
            type: "value",
            name: "flash_memory_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_card_supported_capacity: [
          {
            type: "value",
            name: "memory_card_supported_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        screen_mode: [
          {
            type: "value",
            name: "screen_mode",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        hdmi_out: [
          {
            type: "value",
            name: "hdmi_out",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        microphone: [
          {
            type: "value",
            name: "microphone",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        vpro_technology: [
          {
            type: "value",
            name: "vpro_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        solid_state_drive_interface: [
          {
            type: "value",
            name: "solid_state_drive_interface",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_clock_speed: [
          {
            type: "value",
            name: "memory_clock_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        optical_drive_type: [
          {
            type: "value",
            name: "optical_drive_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_configuration: [
          {
            type: "value",
            name: "memory_configuration",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_processors_supported: [
          {
            type: "value",
            name: "number_of_processors_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_hard_drive_capacity: [
          {
            type: "value",
            name: "total_hard_drive_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        signal_processing: [
          {
            type: "value",
            name: "signal_processing",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        error_checking: [
          {
            type: "value",
            name: "error_checking",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_processors_installed: [
          {
            type: "value",
            name: "number_of_processors_installed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_solid_state_drive_capacity: [
          {
            type: "value",
            name: "total_solid_state_drive_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_total_memory_slots: [
          {
            type: "value",
            name: "number_of_total_memory_slots",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        durability: [
          {
            type: "value",
            name: "durability",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_input_devices_supported: [
          {
            type: "value",
            name: "number_of_input_devices_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        maximum_video_resolution: [
          {
            type: "value",
            name: "maximum_video_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        maximum_operating_distance: [
          {
            type: "value",
            name: "maximum_operating_distance",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        graphics_modes: [
          {
            type: "value",
            name: "graphics_modes",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        tuner: [
          {
            type: "value",
            name: "tuner",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        load_capacity: [
          {
            type: "value",
            name: "load_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        plugconnector_type: [
          {
            type: "value",
            name: "plugconnector_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        phase: [
          {
            type: "value",
            name: "phase",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        backuprun_time: [
          {
            type: "value",
            name: "backuprun_time",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        receptacle_detail: [
          {
            type: "value",
            name: "receptacle_detail",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        output_voltage: [
          {
            type: "value",
            name: "output_voltage",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_battery__surge_outlets: [
          {
            type: "value",
            name: "number_of_battery__surge_outlets",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        transfer_time: [
          {
            type: "value",
            name: "transfer_time",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        receptacle_type: [
          {
            type: "value",
            name: "receptacle_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        rack_height: [
          {
            type: "value",
            name: "rack_height",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        dataline_protection: [
          {
            type: "value",
            name: "dataline_protection",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        battery_capacity: [
          {
            type: "value",
            name: "battery_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_battery_life: [
          {
            type: "value",
            name: "maximum_battery_life",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        minimum_battery_life: [
          {
            type: "value",
            name: "minimum_battery_life",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        battery_characteristics: [
          {
            type: "value",
            name: "battery_characteristics",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        battery_chemistry: [
          {
            type: "value",
            name: "battery_chemistry",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        maximum_operating_temperature: [
          {
            type: "value",
            name: "maximum_operating_temperature",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        avr: [
          {
            type: "value",
            name: "avr",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        hot_swappable: [
          {
            type: "value",
            name: "hot_swappable",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        mount_type: [
          {
            type: "value",
            name: "mount_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        panel_technology: [
          {
            type: "value",
            name: "panel_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        backlight_technology: [
          {
            type: "value",
            name: "backlight_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        camera_resolution: [
          {
            type: "value",
            name: "camera_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        tearing_prevention_technology: [
          {
            type: "value",
            name: "tearing_prevention_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        dvi: [
          {
            type: "value",
            name: "dvi",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        speakers: [
          {
            type: "value",
            name: "speakers",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        standard_refresh_rate: [
          {
            type: "value",
            name: "standard_refresh_rate",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        impact_protection_ik_rating: [
          {
            type: "value",
            name: "impact_protection_ik_rating",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        offmode_power_consumption: [
          {
            type: "value",
            name: "offmode_power_consumption",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        vr_ready: [
          {
            type: "value",
            name: "vr_ready",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        usb_typec_front: [
          {
            type: "value",
            name: "usb_typec_front",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        graphics_processor_core: [
          {
            type: "value",
            name: "graphics_processor_core",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_usb_32_gen_2_ports: [
          {
            type: "value",
            name: "number_of_usb_32_gen_2_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_usb_20_ports: [
          {
            type: "value",
            name: "number_of_usb_20_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_usb_30_ports: [
          {
            type: "value",
            name: "number_of_usb_30_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        usb_typec: [
          {
            type: "value",
            name: "usb_typec",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        intel_optane_memory_capacity: [
          {
            type: "value",
            name: "intel_optane_memory_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        usb_typec_detail: [
          {
            type: "value",
            name: "usb_typec_detail",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        graphics_memory_accessibility: [
          {
            type: "value",
            name: "graphics_memory_accessibility",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        graphics_memory_technology: [
          {
            type: "value",
            name: "graphics_memory_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        ssd_form_factor: [
          {
            type: "value",
            name: "ssd_form_factor",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_number_of_usb_ports: [
          {
            type: "value",
            name: "total_number_of_usb_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        operating_system: [
          {
            type: "value",
            name: "operating_system",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_turbo_speed: [
          {
            type: "value",
            name: "maximum_turbo_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        solid_state_drive_configuration: [
          {
            type: "value",
            name: "solid_state_drive_configuration",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        hard_drive_configuration: [
          {
            type: "value",
            name: "hard_drive_configuration",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        monitor_included: [
          {
            type: "value",
            name: "monitor_included",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        lan_model: [
          {
            type: "value",
            name: "lan_model",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        remote_management: [
          {
            type: "value",
            name: "remote_management",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        redundant_power_supply: [
          {
            type: "value",
            name: "redundant_power_supply",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_total_expansion_bays: [
          {
            type: "value",
            name: "number_of_total_expansion_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_hard_drives_installed: [
          {
            type: "value",
            name: "number_of_hard_drives_installed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        network_standard: [
          {
            type: "value",
            name: "network_standard",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_power_supply_wattage: [
          {
            type: "value",
            name: "maximum_power_supply_wattage",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_power_supplies_installed: [
          {
            type: "value",
            name: "number_of_power_supplies_installed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_power_supplies_supported: [
          {
            type: "value",
            name: "number_of_power_supplies_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_35_bays: [
          {
            type: "value",
            name: "number_of_35_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_hard_drives_supported: [
          {
            type: "value",
            name: "number_of_hard_drives_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_hard_drive_capacity_supported: [
          {
            type: "value",
            name: "total_hard_drive_capacity_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        expansion_slot_type: [
          {
            type: "value",
            name: "expansion_slot_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_broadband_rj45_ports: [
          {
            type: "value",
            name: "number_of_broadband_rj45_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        carrier_supported: [
          {
            type: "value",
            name: "carrier_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        powerline: [
          {
            type: "value",
            name: "powerline",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        wifi_generation: [
          {
            type: "value",
            name: "wifi_generation",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        unii_maximum_frequency: [
          {
            type: "value",
            name: "unii_maximum_frequency",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_number_of_antennas: [
          {
            type: "value",
            name: "total_number_of_antennas",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        poe_rj45_port: [
          {
            type: "value",
            name: "poe_rj45_port",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_total_expansion_slots: [
          {
            type: "value",
            name: "number_of_total_expansion_slots",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        management_port: [
          {
            type: "value",
            name: "management_port",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        power_consumption: [
          {
            type: "value",
            name: "power_consumption",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        unii_band: [
          {
            type: "value",
            name: "unii_band",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_wan_ports: [
          {
            type: "value",
            name: "number_of_wan_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        usb_standard: [
          {
            type: "value",
            name: "usb_standard",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        ism_maximum_frequency: [
          {
            type: "value",
            name: "ism_maximum_frequency",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_internal_antennas: [
          {
            type: "value",
            name: "number_of_internal_antennas",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        broadband_transmission_technology: [
          {
            type: "value",
            name: "broadband_transmission_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_number_of_ports: [
          {
            type: "value",
            name: "total_number_of_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        compatible_rack_unit: [
          {
            type: "value",
            name: "compatible_rack_unit",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        ism_band: [
          {
            type: "value",
            name: "ism_band",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_wireless_transmission_speed: [
          {
            type: "value",
            name: "total_wireless_transmission_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        voip_supported: [
          {
            type: "value",
            name: "voip_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        sim_size_supported: [
          {
            type: "value",
            name: "sim_size_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        vpn_supported: [
          {
            type: "value",
            name: "vpn_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        redundant_power_supply_supported: [
          {
            type: "value",
            name: "redundant_power_supply_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        license_type: [
          {
            type: "value",
            name: "license_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        network_band: [
          {
            type: "value",
            name: "network_band",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        network_technology: [
          {
            type: "value",
            name: "network_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        networking_standards: [
          {
            type: "value",
            name: "networking_standards",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_sim_card_supported: [
          {
            type: "value",
            name: "number_of_sim_card_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_external_antennas: [
          {
            type: "value",
            name: "number_of_external_antennas",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        multisim_supported: [
          {
            type: "value",
            name: "multisim_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_serial_ports: [
          {
            type: "value",
            name: "number_of_serial_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        vga: [
          {
            type: "value",
            name: "vga",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_hard_drive_capacity_installed: [
          {
            type: "value",
            name: "total_hard_drive_capacity_installed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_usb_32_gen_1_ports: [
          {
            type: "value",
            name: "number_of_usb_32_gen_1_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        operating_system_platform: [
          {
            type: "value",
            name: "operating_system_platform",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        hybrid_hard_drive_capacity: [
          {
            type: "value",
            name: "hybrid_hard_drive_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        operation_hours: [
          {
            type: "value",
            name: "operation_hours",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        screen_size_class: [
          {
            type: "value",
            name: "screen_size_class",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        native_contrast_ratio: [
          {
            type: "value",
            name: "native_contrast_ratio",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        stand_adjustments: [
          {
            type: "value",
            name: "stand_adjustments",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_displayports: [
          {
            type: "value",
            name: "number_of_displayports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        contrast_ratio: [
          {
            type: "value",
            name: "contrast_ratio",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        placement: [
          {
            type: "value",
            name: "placement",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        vesa_mount_compatible: [
          {
            type: "value",
            name: "vesa_mount_compatible",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        hdcp_supported: [
          {
            type: "value",
            name: "hdcp_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        color: [
          {
            type: "value",
            name: "color",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        thunderbolt: [
          {
            type: "value",
            name: "thunderbolt",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        curved_screen: [
          {
            type: "value",
            name: "curved_screen",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        touchscreen_type: [
          {
            type: "value",
            name: "touchscreen_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        viewable_screen_size: [
          {
            type: "value",
            name: "viewable_screen_size",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        adjustable_stand_height: [
          {
            type: "value",
            name: "adjustable_stand_height",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_resolution: [
          {
            type: "value",
            name: "maximum_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        ingress_protection_ip_rating: [
          {
            type: "value",
            name: "ingress_protection_ip_rating",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        color_supported: [
          {
            type: "value",
            name: "color_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        multitouch_screen: [
          {
            type: "value",
            name: "multitouch_screen",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_screens: [
          {
            type: "value",
            name: "number_of_screens",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        brightness: [
          {
            type: "value",
            name: "brightness",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        horizontal_frequency: [
          {
            type: "value",
            name: "horizontal_frequency",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        vertical_frequency: [
          {
            type: "value",
            name: "vertical_frequency",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        pixel_pitch: [
          {
            type: "value",
            name: "pixel_pitch",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        dynamic_contrast_ratio: [
          {
            type: "value",
            name: "dynamic_contrast_ratio",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        operating_power_consumption: [
          {
            type: "value",
            name: "operating_power_consumption",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        response_time: [
          {
            type: "value",
            name: "response_time",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        data_transfer_rate: [
          {
            type: "value",
            name: "data_transfer_rate",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_controllable_devices: [
          {
            type: "value",
            name: "number_of_controllable_devices",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        modular: [
          {
            type: "value",
            name: "modular",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_frequency: [
          {
            type: "value",
            name: "maximum_frequency",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_fibre_channel_ports: [
          {
            type: "value",
            name: "number_of_fibre_channel_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        portexpansion_slot_details: [
          {
            type: "value",
            name: "portexpansion_slot_details",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_infiniband_ports: [
          {
            type: "value",
            name: "number_of_infiniband_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        dimmer_type: [
          {
            type: "value",
            name: "dimmer_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        current: [
          {
            type: "value",
            name: "current",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        switch_type: [
          {
            type: "value",
            name: "switch_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        manageable: [
          {
            type: "value",
            name: "manageable",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        current_rating: [
          {
            type: "value",
            name: "current_rating",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        controllable_function: [
          {
            type: "value",
            name: "controllable_function",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        stack_port: [
          {
            type: "value",
            name: "stack_port",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        minimum_frequency: [
          {
            type: "value",
            name: "minimum_frequency",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        uplink_port: [
          {
            type: "value",
            name: "uplink_port",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        power_rating: [
          {
            type: "value",
            name: "power_rating",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        layer_supported: [
          {
            type: "value",
            name: "layer_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_data_transfer_rate: [
          {
            type: "value",
            name: "maximum_data_transfer_rate",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        protection_type: [
          {
            type: "value",
            name: "protection_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        receptacles: [
          {
            type: "value",
            name: "receptacles",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_number_of_network_ports: [
          {
            type: "value",
            name: "total_number_of_network_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        storage_type: [
          {
            type: "value",
            name: "storage_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_focal_length: [
          {
            type: "value",
            name: "maximum_focal_length",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        recording_formats: [
          {
            type: "value",
            name: "recording_formats",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        operating_humidity: [
          {
            type: "value",
            name: "operating_humidity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        lens_type: [
          {
            type: "value",
            name: "lens_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        tilt: [
          {
            type: "value",
            name: "tilt",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        night_vision_type: [
          {
            type: "value",
            name: "night_vision_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        hd_recording: [
          {
            type: "value",
            name: "hd_recording",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        diameter: [
          {
            type: "value",
            name: "diameter",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        video_signal_format: [
          {
            type: "value",
            name: "video_signal_format",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        minimum_operating_temperature: [
          {
            type: "value",
            name: "minimum_operating_temperature",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        effective_camera_resolution: [
          {
            type: "value",
            name: "effective_camera_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        night_vision: [
          {
            type: "value",
            name: "night_vision",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_illumination: [
          {
            type: "value",
            name: "maximum_illumination",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        impact_protection_rating: [
          {
            type: "value",
            name: "impact_protection_rating",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        horizontal_resolution: [
          {
            type: "value",
            name: "horizontal_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        lens_mount_type: [
          {
            type: "value",
            name: "lens_mount_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        longest_shutter_speed: [
          {
            type: "value",
            name: "longest_shutter_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        optical_zoom: [
          {
            type: "value",
            name: "optical_zoom",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        minimum_focal_length: [
          {
            type: "value",
            name: "minimum_focal_length",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        image_sensor_size: [
          {
            type: "value",
            name: "image_sensor_size",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_ir_leds: [
          {
            type: "value",
            name: "number_of_ir_leds",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        night_vision_distance: [
          {
            type: "value",
            name: "night_vision_distance",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_aperture: [
          {
            type: "value",
            name: "maximum_aperture",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        image_sensor_type: [
          {
            type: "value",
            name: "image_sensor_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        video_formats: [
          {
            type: "value",
            name: "video_formats",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        indooroutdoor: [
          {
            type: "value",
            name: "indooroutdoor",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        shortest_shutter_speed: [
          {
            type: "value",
            name: "shortest_shutter_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        minimum_aperture: [
          {
            type: "value",
            name: "minimum_aperture",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        rms_output_power: [
          {
            type: "value",
            name: "rms_output_power",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        software_included: [
          {
            type: "value",
            name: "software_included",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        touchscreen_technology: [
          {
            type: "value",
            name: "touchscreen_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        ambient_light_sensor: [
          {
            type: "value",
            name: "ambient_light_sensor",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_touch_points: [
          {
            type: "value",
            name: "number_of_touch_points",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        webcam: [
          {
            type: "value",
            name: "webcam",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        tempered_glass: [
          {
            type: "value",
            name: "tempered_glass",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        scan_format: [
          {
            type: "value",
            name: "scan_format",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        accessibility: [
          {
            type: "value",
            name: "accessibility",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        style: [
          {
            type: "value",
            name: "style",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_25_bays: [
          {
            type: "value",
            name: "number_of_25_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        rdx_technology: [
          {
            type: "value",
            name: "rdx_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_2535_bays: [
          {
            type: "value",
            name: "number_of_2535_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_solid_state_drive_installed: [
          {
            type: "value",
            name: "number_of_solid_state_drive_installed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_external_525_bays: [
          {
            type: "value",
            name: "number_of_external_525_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        case_capacity: [
          {
            type: "value",
            name: "case_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_solid_state_drive_supported: [
          {
            type: "value",
            name: "number_of_solid_state_drive_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        ssd_cache_capacity: [
          {
            type: "value",
            name: "ssd_cache_capacity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        host_interface: [
          {
            type: "value",
            name: "host_interface",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        case_component: [
          {
            type: "value",
            name: "case_component",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        noise_levels: [
          {
            type: "value",
            name: "noise_levels",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        connectors: [
          {
            type: "value",
            name: "connectors",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fan_speed_min: [
          {
            type: "value",
            name: "fan_speed_min",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        rated_current: [
          {
            type: "value",
            name: "rated_current",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        compatible_amd_socket: [
          {
            type: "value",
            name: "compatible_amd_socket",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_fan_diameter: [
          {
            type: "value",
            name: "maximum_fan_diameter",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        heatsink_depth: [
          {
            type: "value",
            name: "heatsink_depth",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        noise_levels_aweighted: [
          {
            type: "value",
            name: "noise_levels_aweighted",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_airflow: [
          {
            type: "value",
            name: "maximum_airflow",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_fans: [
          {
            type: "value",
            name: "number_of_fans",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        heatsink_width: [
          {
            type: "value",
            name: "heatsink_width",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        radiator_material: [
          {
            type: "value",
            name: "radiator_material",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        heatsink_height: [
          {
            type: "value",
            name: "heatsink_height",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fan_life: [
          {
            type: "value",
            name: "fan_life",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_air_pressure: [
          {
            type: "value",
            name: "maximum_air_pressure",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fan_width: [
          {
            type: "value",
            name: "fan_width",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        led_color: [
          {
            type: "value",
            name: "led_color",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fan_depth: [
          {
            type: "value",
            name: "fan_depth",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fan_height: [
          {
            type: "value",
            name: "fan_height",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        compatible_intel_socket: [
          {
            type: "value",
            name: "compatible_intel_socket",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        minimum_airflow: [
          {
            type: "value",
            name: "minimum_airflow",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        minimum_fan_diameter: [
          {
            type: "value",
            name: "minimum_fan_diameter",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        cooler_type: [
          {
            type: "value",
            name: "cooler_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fan_bearing_type: [
          {
            type: "value",
            name: "fan_bearing_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        radiator_width: [
          {
            type: "value",
            name: "radiator_width",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fan_material: [
          {
            type: "value",
            name: "fan_material",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fan_speed_max: [
          {
            type: "value",
            name: "fan_speed_max",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        radiator_height: [
          {
            type: "value",
            name: "radiator_height",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        heatsink_material: [
          {
            type: "value",
            name: "heatsink_material",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_speed: [
          {
            type: "value",
            name: "memory_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        thickness: [
          {
            type: "value",
            name: "thickness",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_voltage: [
          {
            type: "value",
            name: "memory_voltage",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_modules: [
          {
            type: "value",
            name: "number_of_modules",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_rank: [
          {
            type: "value",
            name: "memory_rank",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_pins: [
          {
            type: "value",
            name: "number_of_pins",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        rgb: [
          {
            type: "value",
            name: "rgb",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        cas_latency: [
          {
            type: "value",
            name: "cas_latency",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        nonrgb: [
          {
            type: "value",
            name: "nonrgb",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        memory_size: [
          {
            type: "value",
            name: "memory_size",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        mini_hdmi: [
          {
            type: "value",
            name: "mini_hdmi",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        multigpu_technology: [
          {
            type: "value",
            name: "multigpu_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        mini_displayport: [
          {
            type: "value",
            name: "mini_displayport",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_gpus: [
          {
            type: "value",
            name: "number_of_gpus",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_displayport_outputs: [
          {
            type: "value",
            name: "number_of_displayport_outputs",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        chipset_series: [
          {
            type: "value",
            name: "chipset_series",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        bus_width: [
          {
            type: "value",
            name: "bus_width",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_dvii_ports: [
          {
            type: "value",
            name: "number_of_dvii_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        power_supply_wattage: [
          {
            type: "value",
            name: "power_supply_wattage",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        power_connector: [
          {
            type: "value",
            name: "power_connector",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        gpu_boost_clock: [
          {
            type: "value",
            name: "gpu_boost_clock",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        gpu_clock: [
          {
            type: "value",
            name: "gpu_clock",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_mini_hdmi_outputs: [
          {
            type: "value",
            name: "number_of_mini_hdmi_outputs",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        cuda_cores: [
          {
            type: "value",
            name: "cuda_cores",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        card_length: [
          {
            type: "value",
            name: "card_length",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        host_interface_connector_type: [
          {
            type: "value",
            name: "host_interface_connector_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_monitors_supported: [
          {
            type: "value",
            name: "number_of_monitors_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_usb_typec_ports: [
          {
            type: "value",
            name: "number_of_usb_typec_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_number_of_dvi_outputs: [
          {
            type: "value",
            name: "total_number_of_dvi_outputs",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_digital_display_resolution: [
          {
            type: "value",
            name: "maximum_digital_display_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_dvid_ports: [
          {
            type: "value",
            name: "number_of_dvid_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        dual_link_dvi_supported: [
          {
            type: "value",
            name: "dual_link_dvi_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        card_height: [
          {
            type: "value",
            name: "card_height",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        game_clock: [
          {
            type: "value",
            name: "game_clock",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        api_supported: [
          {
            type: "value",
            name: "api_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        chipset_line: [
          {
            type: "value",
            name: "chipset_line",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        slot_space_required: [
          {
            type: "value",
            name: "slot_space_required",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_mini_displayport_outputs: [
          {
            type: "value",
            name: "number_of_mini_displayport_outputs",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_external_25_bays: [
          {
            type: "value",
            name: "number_of_external_25_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_internal_2535_bays: [
          {
            type: "value",
            name: "number_of_internal_2535_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_external_35_bays: [
          {
            type: "value",
            name: "number_of_external_35_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        power_supply_installed: [
          {
            type: "value",
            name: "power_supply_installed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_fans_installed: [
          {
            type: "value",
            name: "number_of_fans_installed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        front_audio_in: [
          {
            type: "value",
            name: "front_audio_in",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        motherboard_supported: [
          {
            type: "value",
            name: "motherboard_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_psu_length: [
          {
            type: "value",
            name: "maximum_psu_length",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_internal_525_bays: [
          {
            type: "value",
            name: "number_of_internal_525_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        gift_type: [
          {
            type: "value",
            name: "gift_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        usb_port_details: [
          {
            type: "value",
            name: "usb_port_details",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        installed_fan_size: [
          {
            type: "value",
            name: "installed_fan_size",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_number_of_audio_in_ports: [
          {
            type: "value",
            name: "total_number_of_audio_in_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_number_of_audio_out_ports: [
          {
            type: "value",
            name: "total_number_of_audio_out_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        front_audio_out: [
          {
            type: "value",
            name: "front_audio_out",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        front_usb: [
          {
            type: "value",
            name: "front_usb",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_internal_25_bays: [
          {
            type: "value",
            name: "number_of_internal_25_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_external_2535_bays: [
          {
            type: "value",
            name: "number_of_external_2535_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_fans_supported: [
          {
            type: "value",
            name: "number_of_fans_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        audio_line_out: [
          {
            type: "value",
            name: "audio_line_out",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_internal_35_bays: [
          {
            type: "value",
            name: "number_of_internal_35_bays",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_cpu_cooler_height: [
          {
            type: "value",
            name: "maximum_cpu_cooler_height",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        cable_length: [
          {
            type: "value",
            name: "cable_length",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        polar_pattern: [
          {
            type: "value",
            name: "polar_pattern",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        impedance: [
          {
            type: "value",
            name: "impedance",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        microphone_technology: [
          {
            type: "value",
            name: "microphone_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        microphone_sensitivity: [
          {
            type: "value",
            name: "microphone_sensitivity",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        noise_canceling: [
          {
            type: "value",
            name: "noise_canceling",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        wireless_operating_distance: [
          {
            type: "value",
            name: "wireless_operating_distance",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        microphone_type: [
          {
            type: "value",
            name: "microphone_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        minimum_frequency_response: [
          {
            type: "value",
            name: "minimum_frequency_response",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        plating: [
          {
            type: "value",
            name: "plating",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        microphone_controls: [
          {
            type: "value",
            name: "microphone_controls",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_frequency_response: [
          {
            type: "value",
            name: "maximum_frequency_response",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        wireless_technology: [
          {
            type: "value",
            name: "wireless_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        price: [
          {
            type: "range",
            name: "price",
            ranges: [
              { from: 25, to: 50 },
              { from: 50, to: 75 },
              { from: 75, to: 100 },
              { from: 100, to: 125 },
              { from: 125, to: 150 },
              { from: 150, to: 175 },
              { from: 175, to: 200 },
              { from: 200, to: 250 },
              { from: 250, to: 300 },
              { from: 300, to: 350 },
              { from: 350, to: 400 },
              { from: 400, to: 450 },
              { from: 450, to: 500 },
              { from: 500, to: 550 },
              { from: 550, to: 600 },
              { from: 600, to: 650 },
              { from: 650, to: 700 },
              { from: 700, to: 750 },
              { from: 750, to: 800 },
              { from: 800, to: 850 },
              { from: 850, to: 900 },
              { from: 900, to: 950 },
              { from: 950, to: 1000 },
              { from: 1000, to: 1250 },
              { from: 1250, to: 1500 },
              { from: 1500, to: 1750 },
              { from: 1750, to: 2000 },
              { from: 2000, to: 2250 },
              { from: 2250, to: 2500 },
              { from: 2500, to: 2750 },
              { from: 2750, to: 3000 },
              { from: 3000, to: 3250 },
              { from: 3250, to: 3500 },
              { from: 3500, to: 3750 },
              { from: 3750, to: 4000 },
              { from: 4000, to: 4250 },
              { from: 4250, to: 4500 },
              { from: 4500, to: 4750 },
              { from: 4750, to: 5000 },
              { from: 5000, to: 5250 },
              { from: 5250, to: 5500 },
              { from: 5500, to: 5750 },
              { from: 5750, to: 6000 },
              { from: 6000, to: 6250 },
              { from: 6250, to: 6500 },
              { from: 6500, to: 6750 },
              { from: 6750, to: 7000 },
              { from: 7000, to: 7250 },
              { from: 7250, to: 7500 },
              { from: 7500, to: 7750 },
              { from: 7750, to: 8000 },
              { from: 8000, to: 8250 },
              { from: 8250, to: 8500 },
              { from: 8500, to: 8750 },
              { from: 8750, to: 9000 },
              { from: 9000, to: 9250 },
              { from: 9250, to: 9500 },
              { from: 9500, to: 9750 },
              { from: 9750, to: 10000 },
              { from: 10000 },
            ],
          },
        ],
  
        serial_in: [
          {
            type: "value",
            name: "serial_in",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        widescreen: [
          {
            type: "value",
            name: "widescreen",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        focus_modes: [
          {
            type: "value",
            name: "focus_modes",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        digital_zoom: [
          {
            type: "value",
            name: "digital_zoom",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        serial_out: [
          {
            type: "value",
            name: "serial_out",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        face_tracking: [
          {
            type: "value",
            name: "face_tracking",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        effective_resolution: [
          {
            type: "value",
            name: "effective_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        mounting_type: [
          {
            type: "value",
            name: "mounting_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        interpolated_resolution: [
          {
            type: "value",
            name: "interpolated_resolution",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_frame_rate: [
          {
            type: "value",
            name: "maximum_frame_rate",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        surface_material: [
          {
            type: "value",
            name: "surface_material",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        printed_designpatterntexture: [
          {
            type: "value",
            name: "printed_designpatterntexture",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        size: [
          {
            type: "value",
            name: "size",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        filling_material: [
          {
            type: "value",
            name: "filling_material",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        combined_processor_core: [
          {
            type: "value",
            name: "combined_processor_core",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_supported_system_memory: [
          {
            type: "value",
            name: "maximum_supported_system_memory",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        intel_evo_platform: [
          {
            type: "value",
            name: "intel_evo_platform",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        release_month: [
          {
            type: "value",
            name: "release_month",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        system_memory_technology: [
          {
            type: "value",
            name: "system_memory_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        installed_slot_memory_configuration: [
          {
            type: "value",
            name: "installed_slot_memory_configuration",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_number_of_memory_slots: [
          {
            type: "value",
            name: "total_number_of_memory_slots",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        system_memory_speed: [
          {
            type: "value",
            name: "system_memory_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        optical_media_supported: [
          {
            type: "value",
            name: "optical_media_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        drive_type: [
          {
            type: "value",
            name: "drive_type",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        release_year: [
          {
            type: "value",
            name: "release_year",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        onboard_memory: [
          {
            type: "value",
            name: "onboard_memory",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        system_memory_form_factor: [
          {
            type: "value",
            name: "system_memory_form_factor",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        total_installed_system_memory: [
          {
            type: "value",
            name: "total_installed_system_memory",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        onboard_memory_technology: [
          {
            type: "value",
            name: "onboard_memory_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
  
        number_of_occupied_memory_slots: [
          {
            type: "value",
            name: "number_of_occupied_memory_slots",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        builtin_outlet: [
          {
            type: "value",
            name: "builtin_outlet",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        phone_line_rj11: [
          {
            type: "value",
            name: "phone_line_rj11",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        powerline_data_transfer_rate: [
          {
            type: "value",
            name: "powerline_data_transfer_rate",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        wireless_transmission_speed: [
          {
            type: "value",
            name: "wireless_transmission_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        maximum_distance_supported: [
          {
            type: "value",
            name: "maximum_distance_supported",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        area_coverage: [
          {
            type: "value",
            name: "area_coverage",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        powerline_transmission_standard: [
          {
            type: "value",
            name: "powerline_transmission_standard",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        audio_line_in: [
          {
            type: "value",
            name: "audio_line_in",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_phone_line_rj11_ports: [
          {
            type: "value",
            name: "number_of_phone_line_rj11_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        modem_transmission_data_rate: [
          {
            type: "value",
            name: "modem_transmission_data_rate",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        modulation: [
          {
            type: "value",
            name: "modulation",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        broadband_transmission_speed: [
          {
            type: "value",
            name: "broadband_transmission_speed",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        number_of_modem_rj11_ports: [
          {
            type: "value",
            name: "number_of_modem_rj11_ports",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fax_transmission_data_rate: [
          {
            type: "value",
            name: "fax_transmission_data_rate",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        fax_technology: [
          {
            type: "value",
            name: "fax_technology",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
        ftype: [
          {
            type: "value",
            name: "ftype",
            sort: {
              count: "desc",
            },
            size: 200,
          },
        ],
      },
    };
  }


  //update the options object with the local filters
  const facetTranslations = {
    de: {
      price: "Preis",
      condition: "Zustand",
      vendor: "Anbieter",
    },
    ar: {
      price: "السعر",
      condition: "الحالة",
      vendor: "البائع",
    },
    ja: {
      price: "価格",
      condition: "状態",
      vendor: "販売者",
    },
    it: {
      price: "Prezzo",
      condition: "Condizione",
      vendor: "Venditore",
    },
    fr: {
      price: "Prix",
      condition: "État",
      vendor: "Vendeur",
    },
    es: {
      price: "Precio",
      condition: "Condición",
      vendor: "Vendedor",
    },
    zh: {
      price: "价格",
      condition: "状态",
      vendor: "供应商",
    },
    nl: {
      price: "Prijs",
      condition: "Staat",
      vendor: "Verkoper",
    },
    cz: {
      price: "Cena",
      condition: "Stav",
      vendor: "Prodejce",
    },
    da: {
      price: "Pris",
      condition: "Tilstand",
      vendor: "Sælger",
    },
    el: {
      price: "Τιμή",
      condition: "Κατάσταση",
      vendor: "Πωλητής",
    },
    kz: {
      price: "Баға",
      condition: "Жағдайы",
      vendor: "Сатушы",
    },
    pt: {
      price: "Preço",
      condition: "Condição",
      vendor: "Vendedor",
    },
    ro: {
      price: "Preț",
      condition: "Condiție",
      vendor: "Vânzător",
    },
    sv: {
      price: "Pris",
      condition: "Skick",
      vendor: "Säljare",
    },
    th: {
      price: "ราคา",
      condition: "สภาพ",
      vendor: "ผู้ขาย",
    },
    vi: {
      price: "Giá",
      condition: "Tình trạng",
      vendor: "Người bán",
    },
    fi: {
      price: "Hinta",
      condition: "Kunto",
      vendor: "Myyjä",
    },
    no: {
      price: "Pris",
      condition: "Tilstand",
      vendor: "Selger",
    },
    ko: {
      price: "가격",
      condition: "상태",
      vendor: "판매자",
    },
  };
  const searchPlaceholderTranslations = {
    de: "Filter suchen",
    ar: "بحث الفلتر",
    ja: "フィルターを検索",
    it: "Cerca filtro",
    fr: "Rechercher un filtre",
    es: "Buscar filtro",
    zh: "搜索筛选器",
    nl: "Filter zoeken",
    cz: "Hledat filtr",
    da: "Søg filter",
    el: "Αναζήτηση φίλτρου",
    kz: "Сүзгіні іздеу",
    pt: "Pesquisar filtro",
    ro: "Căutare filtru",
    sv: "Sök filter",
    th: "ค้นหาตัวกรอง",
    vi: "Tìm kiếm bộ lọc",
    fi: "Hae suodatin",
    no: "Søk filter",
    ko: "필터 검색"
  };
  const productCountTranslations = {
    en: {
      of: "of",
      products: "products",
      noProductsFound: "No Products Found"
    },
    de: {
      of: "von",
      products: "Produkte",
      noProductsFound: "Keine Produkte gefunden"
    },
    ar: {
      of: "من",
      products: "منتجات",
      noProductsFound: "لم يتم العثور على منتجات"
    },
    ja: {
      of: "の",
      products: "製品",
      noProductsFound: "製品が見つかりません"
    },
    it: {
      of: "di",
      products: "prodotti",
      noProductsFound: "Nessun prodotto trovato"
    },
    fr: {
      of: "sur",
      products: "produits",
      noProductsFound: "Aucun produit trouvé"
    },
    es: {
      of: "de",
      products: "productos",
      noProductsFound: "No se encontraron productos"
    },
    zh: {
      of: "的",
      products: "产品",
      noProductsFound: "未找到产品"
    },
    nl: {
      of: "van",
      products: "producten",
      noProductsFound: "Geen producten gevonden"
    },
    cz: {
      of: "z",
      products: "produktů",
      noProductsFound: "Nebyly nalezeny žádné produkty"
    },
    da: {
      of: "af",
      products: "produkter",
      noProductsFound: "Ingen produkter fundet"
    },
    el: {
      of: "από",
      products: "προϊόντα",
      noProductsFound: "Δεν βρέθηκαν προϊόντα"
    },
    kz: {
      of: "/",
      products: "өнімдер",
      noProductsFound: "Өнімдер табылмады"
    },
    pt: {
      of: "de",
      products: "produtos",
      noProductsFound: "Nenhum produto encontrado"
    },
    ro: {
      of: "din",
      products: "produse",
      noProductsFound: "Nu s-au găsit produse"
    },
    sv: {
      of: "av",
      products: "produkter",
      noProductsFound: "Inga produkter hittades"
    },
    th: {
      of: "จาก",
      products: "สินค้า",
      noProductsFound: "ไม่พบสินค้า"
    },
    vi: {
      of: "của",
      products: "sản phẩm",
      noProductsFound: "Không tìm thấy sản phẩm nào"
    },
    fi: {
      of: "/",
      products: "tuotetta",
      noProductsFound: "Tuotteita ei löytynyt"
    },
    no: {
      of: "av",
      products: "produkter",
      noProductsFound: "Ingen produkter funnet"
    },
    ko: {
      of: "중",
      products: "제품",
      noProductsFound: "제품을 찾을 수 없습니다"
    }
  };


  const renderFacetName = (type) => {
    if (facetTranslations[language] && facetTranslations[language][type]) {
      return capitalizeEachWord(facetTranslations[language][type]);
    }
    return capitalizeEachWord(type.split("_").join(" "));
  };



  //dynamic engine name
  var client = ElasticAppSearch.createClient({
    searchKey: "search-5rbimazsc8rrj4yyektfmwoe",
    endpointBase: "https://abloom-ai.ent.us-west1.gcp.cloud.es.io:9243",
    engineName: engineName,
  });

  var total_res = 0;
  const currencyRate = Shopify.currency.rate;
  const currency = document
    .querySelector(".header-container")
    .getAttribute("data-currency");
  let minPrice;
  let maxPrice;


  const isCollectionPath =
    window.location.pathname.includes("/collections") &&
    !window.location.pathname.includes("/search");

  const getTotal = async () => {
    if (isSearchPath || isCollectionPath) {
      const { query, search_fields, filters, ...rests } = options;
      const tempOpt = isSearchPath
        ? { query, search_fields, filters }
        : { filters, query };

      // Cloud Function URL
      
      const functionUrl = "https://us-west1-fetchsome.cloudfunctions.net/function-searcai";
      
      const queryTextToSend = tempOpt.query || "";
      const filtersToSend = tempOpt.filters || {};
      const searchFieldsToSend =  JSON.stringify(tempOpt.search_fields || {});

      try {
        const response = await fetch(functionUrl, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({  
              queryText: queryTextToSend,
              filters: filtersToSend,
          }),
        });
        const data = await response.json();

        total_res = data.filteredTotal || 0;
        return data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  if (isSearchPath) {
    options.search_fields = {
      title: { weight: 10 },
      vendor: { weight: 10 },
    };
    options.filters.all = [{ status: "ACTIVE" }];

  } else if (isCollectionPath) {
    // const collection = document
    //   .getElementById("page-collections")
    //   .getAttribute("data-collection")
    //   .replaceAll('"', '"');
    const collectionHandle = document
      .getElementById("page-collections")
      .getAttribute("data-handle");
    options.filters.all = [
      { collection_handles: [`${collectionHandle.replaceAll('"', '"')}`] },
      { status: "ACTIVE" },
      { total_inventory: true},

    ];

    if (window.location.pathname.includes("/vendors")) {
      options.filters.all = [
        { vendor: [collectionHandle] },
        { status: "ACTIVE" },
      ];
    }
  }

  const getInitialUrlCollection = async () => {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const pathIncludesSearch = window.location.pathname.includes("/search");
    const pathIncludesVendors = window.location.pathname.includes("/vendors");
    const pathIncludesCollection =
      window.location.pathname.includes("/collections");

    const query = params.get("q");
    const q_within = params.get("q_within");
    const sortNumber = params.get("sort_number");
    if (sortNumber == "true") {
      const checkNox = document.querySelector(".switch input");
      if (checkNox) checkNox.checked = true;
    } else {
      const checkNox = document.querySelector(".switch input");
      if (checkNox) checkNox.checked = false;
    }

    if (query && pathIncludesSearch) {
      const customQueries = [
        {
          query: ["laptop", "laptops", "notebook", "notebooks"],
          collection_handle: "laptops-notebooks",
        },
        //{
        //  query: ["mouse", "mice"],
        //  collection_handle: "computer-mouse"
        //},
        {
          query: ["keyboard", "keyboards"],
          collection_handle: "keyboards-keypads"
        }
      ]

      options.query = query;

      if (customQueries.some((i) => i.query.includes(query))){
        const collection = customQueries.find((i) => i.query.includes(query));
        options.filters.all.push({ collection_handles: [`${collection.collection_handle}`] });
      }
    }

    if (!pathIncludesVendors) {
      await getTotal();
    }

    if (pathIncludesVendors && query) {
      options.filters.all = [{ vendor: [String(query)] }, { status: "ACTIVE" }];
      await getTotal();
    }

    const processPrice = (price) => {
      if (price.includes("+")) {
        const [from] = price.split("+");
        return {
          price: { from: Number(from) },
        };
      }
      const [from, to] = price.split("-");
      minPrice = from.slice(0, -1);
      maxPrice = to;

      return {
        price: { from: Number(from), to: to ? Number(to) : undefined },
      };
    };

    params.forEach((value, key) => {
      if (pathIncludesSearch && key === "q") {
        options.query = String(value);
        return;
      }
      if (key === "sort_number") {
        if (value == "true") {
          options.filters.any = [{ sort_number: ["1", "2"] }];
        }
        return;
      }

      if (pathIncludesVendors && key === "q") {
        options.filters.all = [
          { vendor: [String(value)] },
          { status: "ACTIVE" },
        ];
        return;
      }

      if (!options.facets.hasOwnProperty(key)) {
        return;
      }

      const facetIndex = options.facets[key]?.findIndex(
        (facet) => facet.name === key
      );

      if (facetIndex !== -1) {
        if (key === "price") {
          options.filters.all.push({ any: value.split(",").map(processPrice) });
          return;
        }

        const facetType = key;
        const facetValues = value.split(",");

        if (facetValues.length > 1) {
          facetValues.forEach((value) => {
            const index = options.filters.all.findIndex((filter) =>
              filter.hasOwnProperty(key)
            );

            if (index !== -1) {
              options.filters.all[index][facetType].push(value);
            } else {
              options.filters.all.push({ [facetType]: [value] });
            }
          });
        } else {
          const index = options.filters.all.findIndex((filter) =>
            filter.hasOwnProperty(key)
          );

          if (index !== -1) {
            options.filters.all[index][facetType].push(value);
          } else {
            options.filters.all.push({ [facetType]: [value] });
          }
        }
      }
    });

    const sort = params.get("sort");

    if (sort) {
      const [sortKey, sortValue] = sort.split("-");
      //options.sort = [{ total_ordered_quantity: "desc" }];
    } else {
      //options.sort = [{ total_ordered_quantity: "desc" }];
    }

    const page = params.get("page");

    try {
      if (page) {
        options.page.current = Number(page);
        await fetchFacets(options, Number(page));
      } else {
        await fetchFacets(options);
      }
    } catch (error) {
      console.error("Error fetching facets:", error);
    }
  };

  const updateUrl = () => {
    const url = new URL(window.location.href.split("?")[0]);
    const params = url.searchParams;

    // Clear all existing parameters
    params.forEach((_, key) => {
      params.delete(key);
    });

    if (window.location.pathname.includes("/search")) {
      params.set("q", options.query);
    }

    if (window.location.pathname.includes("/collections")) {
      if (options.query) params.set("q_within", options.query);
    }

    const priceValues = options.filters.all
      .filter((filter) => !(filter.collection_handles || filter.status))
      .flatMap((filter) => {
        const type = Object.keys(filter)[0];

        if (type === "any") {
          return filter.any.map((price) => {
            const from = price.price.from;
            const to = price.price.to;
            return to && from ? `${from}-${to}` : to ? `0-${to}` : `${from}+`;
          });
        }

        const values = filter[type];

        if (values && values.length >= 1) {
          const urlValue = params.get(type);
          // debugger;
          if (urlValue) {
            params.delete(type);
            params.set(type, values.join(","));
          } else {
            params.set(type, values.join(","));
          }
        } else {
          params.append(type, values[0]);
        }

        return [];
      });
    if (options.filters.any) {
      const switchValues = options.filters.any;
      if (switchValues && switchValues.length >= 1) {
        params.append("sort_number", "true");
      } else {
        if (params.get("sort_number")) {
          params.delete("sort_number");
        }
      }
    }

    if (priceValues.length > 0) {
      params.set("price", priceValues.join(","));
    }

    // Add sort to URL params
    if (options.sort) {
      const sortTemp = options.sort;
      //find in the sort !total_inventory
      const sort = sortTemp.find((i) => !i.total_inventory);
      if (sort == undefined) {
        params.delete("sort");
      } else {
        const sortKey = Object.keys(sort)[0];
        const sortValue = sort[sortKey];
        params.set("sort", `${sortKey}-${sortValue}`);
      }
    }

    // Add page to URL params
    const page = options.page.current;
    params.set("page", page);

    window.history.pushState({}, "", url);
  };

  const generateMarkUpForProduct = (
    _title,
    _image,
    _price,
    _id,
    _handle,
    _desc,
    _variant_id,
    _compare_at_price,
    _vendor,
    _availabity,
    _image2,
    first,
    count,
    _yotpo_reviews_count = 0
  ) => {
    if (!_image2 && !_image) {
      return "";
    }

    const title = _title.replace(/"/g, '\\"');
    const image = _image ? _image + "&width=700" : _image;
    const image2 = _image2
      ? _image2.replace("size=Maximum", "size=700")
      : _image2;
    const price = _price;
    const vendor = _vendor;
    const compare_at_price = _compare_at_price;
    const id = _id;
    const variant_id = _variant_id;
    const availabity = _availabity;
    const desc = _desc;
    const handle = _handle;
    let showReview = false;
    if (_yotpo_reviews_count) {
      if (_yotpo_reviews_count > 0) {
        showReview = true;
      }
    }

    return `
    <li class="list-item-desktop hide-item">
    
    
  <div style="height:max-content;display:flex;align-items:flex-start; padding:1.5rem; background: white; border-top-left-radius: 3px; border-top-right-radius: 3px; border: 1px #E0E0E0 solid">
  <div style="width:15%;align-self: center;" class="product-image-container">
            <a href='${
              window.Shopify.routes.root
            }products/${handle}' class="image-wrapper" aria-label='${title}'>
              <img class="product-image render-image" ${
                first ? `loading="eager"` : `loading="lazy"`
              } alt="${title}" data-src="${image || image2}" src="${
      image || image2
    }" srcset="${
      image || image2
    } 390w, ${image2} 250w" sizes="(max-width: 600px) 250px, 390px" width="877" height="877">
            </a>
            
          </div>
  <div style="padding:0 1.5rem; width:60%; ">
   <div style="margin-bottom:1rem;width:100%; left: 219px; top: 24px;  color: #1B1919; font-size: 22px; font-family: Roboto; font-weight: 500; word-wrap: break-word"><a href="${
     window.Shopify.routes.root
   }products/${handle}">${title}</a></div>
   <a href="/search?q=${vendor}" aria-label="${vendor}">
                <div style="margin-bottom:1rem;width:100%;   color: #1B1919; font-size: 16px; font-family: Roboto; font-weight: 500; word-wrap: break-word">${vendor} </div>
              </a>
  
  
  <div style="width: 100%; min-height:160px; max-height:160px; overflow-x:hidden; overflow-y:scroll;  color: #424242; font-size: 14px; font-family: Roboto; font-weight: 400; line-height: 22px; word-wrap: break-all">${
    desc == null
      ? ""
      : desc

          .replaceAll("&", "&amp;")
          .replaceAll("<p>", "")
          .replaceAll("</p>", "")
          .replaceAll("<br>", "")
          .replaceAll("</br>", "")
          .replaceAll("<b>", "")
          .replaceAll("</b>", "")
          .replaceAll("<", "&lt;")
          .replaceAll(">", "&gt;")
          .replaceAll('"', "&quot;")
          .replaceAll("'", "&#039;")
  }</div>
  </div>
  <div style="padding:0 1.5rem; width:25%; display:flex; flex-direction:column; gap:0.5rem;">
  <script type="application/json">
  {
    "id": ${id.slice(
      id.indexOf((i) => i == "|"),
      id.length
    )},
    "title": "${title}",
    "variant_id": ${variant_id},
    "handle": "${handle}",
    "price": "${price}",
    "compare_at_price": "${compare_at_price}",
    "image": "${image || image2}",
    "url": "${window.Shopify.routes.root}products/${handle}",
    "vendor": "${vendor}",
    "availabity": ${availabity},
    "img2": "${image2}",
    "img2250": "${image2}"
  }
</script>
  <div >
  <h4 style="${
    availabity && count <= 5
      ? "color:#DF2F2F;font-size: 0.8125rem;font-style: normal;font-weight: 400;line-height: normal;"
      : "color:#219653;font-size: 0.8125rem;font-style: normal;font-weight: 400;line-height: normal;"
  }">
                ${
                  availabity
                    ? window.productCard.inStock
                    : window.productCard.soldOut
                }
              </h4>
  </div>
  <div style="display:flex; gap:0.5rem; align-items:baseline;">
  <div style="color: #1B1919;
font-family: Roboto;
font-size: 1.875rem;
font-style: normal;
font-weight: 500;
line-height: normal;">
   
                      ${
                        currency +
                        String(CurrencyFormatted(Number(price).toFixed(2)))
                      }
                      </div>
                      <div>
                      ${
                        compare_at_price > price
                          ? `<p style="color: #424242;

font-family: Roboto;
font-size: 1.125rem;
font-style: normal;
font-weight: 500;
line-height: normal;text-decoration: line-through;">${
                              currency +
                              String(
                                CurrencyFormatted(
                                  Number(compare_at_price).toFixed(2)
                                )
                              )
                            }</p>`
                          : ""
                      }
                      </div>
  </div>
  <div >
  ${
    compare_at_price > price
      ? `<div  style="margin-bottom:1.5rem; background-color:unset; color:#DF2F2F; padding:0;" class="product-badge"><span style="color: #DF2F2F;

font-family: Roboto;
font-size: 0.6875rem;
font-style: normal;
font-weight: 400;
line-height: normal;">Save</span> ${
          currency +
          String(CurrencyFormatted(Number(compare_at_price - price).toFixed(2)))
        }</div>`
      : ""
  } 
  </div>
  <div class="product-button-container">

           
            ${
              availabity
                ? `<add-to-cart style="background:#232323; border-radius: 0.1875rem;  color:white; padding:0.5rem 0; width:100%; display: flex;
    justify-content: center;
    align-items: center;" class="product-button add-to-cart-button${id}" product-handle="${handle}"><svg style="margin-right:0.5rem;" width="25" height="24" viewBox="0 0 25 24" fill="none" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg">  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H1.33877H1.33883C1.61048 2.00005 2.00378 2.23945 2.10939 2.81599L2.10937 2.816L2.11046 2.82171L5.01743 18.1859C5.12011 18.7286 5.64325 19.0852 6.18591 18.9826C6.21078 18.9779 6.23526 18.9723 6.25933 18.9658C6.28646 18.968 6.31389 18.9692 6.34159 18.9692H18.8179H18.8181C19.0302 18.9691 19.2141 18.9765 19.4075 18.9842L19.4077 18.9842C19.5113 18.9884 19.6175 18.9926 19.7323 18.9959C20.0255 19.0043 20.3767 19.0061 20.7177 18.9406C21.08 18.871 21.4685 18.7189 21.8028 18.3961C22.1291 18.081 22.3266 17.6772 22.4479 17.2384C22.4569 17.2058 22.4642 17.1729 22.4699 17.1396L23.944 8.46865C24.2528 7.20993 23.2684 5.99987 21.9896 6H21.9894H4.74727L4.07666 2.45562L4.07608 2.4525C3.83133 1.12381 2.76159 8.49962e-05 1.33889 0H1.33883H1ZM5.12568 8L6.8227 16.9692H18.8178H18.8179C19.0686 16.9691 19.3257 16.9793 19.5406 16.9877L19.5413 16.9877C19.633 16.9913 19.7171 16.9947 19.7896 16.9967C20.0684 17.0047 20.2307 16.9976 20.3403 16.9766C20.3841 16.9681 20.4059 16.96 20.4151 16.9556C20.4247 16.9443 20.4639 16.8918 20.5077 16.7487L21.9794 8.09186C21.9842 8.06359 21.9902 8.03555 21.9974 8.0078C21.9941 8.00358 21.9908 8.00108 21.989 8H5.12568ZM20.416 16.9552C20.4195 16.9534 20.4208 16.9524 20.4205 16.9523C20.4204 16.9523 20.4199 16.9525 20.4191 16.953L20.416 16.9552ZM10.8666 22.4326C10.8666 23.2982 10.195 24 9.36658 24C8.53815 24 7.86658 23.2982 7.86658 22.4326C7.86658 21.567 8.53815 20.8653 9.36658 20.8653C10.195 20.8653 10.8666 21.567 10.8666 22.4326ZM18.0048 24C18.8332 24 19.5048 23.2982 19.5048 22.4326C19.5048 21.567 18.8332 20.8653 18.0048 20.8653C17.1763 20.8653 16.5048 21.567 16.5048 22.4326C16.5048 23.2982 17.1763 24 18.0048 24Z" fill="currentColor"></path></svg>${window.productCard.addToCart}</add-to-cart>`
                : `<button style="background:#F7F7FA; border-radius: 0.1875rem;  color:white; padding:0.5rem 0; width:100%; display: flex;
    justify-content: center;
    align-items: center;"   class="product-button add-to-cart-button${id}" disabled><svg style="margin-right:0.5rem;" width="25" height="24" viewBox="0 0 25 24" fill="none" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg">  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H1.33877H1.33883C1.61048 2.00005 2.00378 2.23945 2.10939 2.81599L2.10937 2.816L2.11046 2.82171L5.01743 18.1859C5.12011 18.7286 5.64325 19.0852 6.18591 18.9826C6.21078 18.9779 6.23526 18.9723 6.25933 18.9658C6.28646 18.968 6.31389 18.9692 6.34159 18.9692H18.8179H18.8181C19.0302 18.9691 19.2141 18.9765 19.4075 18.9842L19.4077 18.9842C19.5113 18.9884 19.6175 18.9926 19.7323 18.9959C20.0255 19.0043 20.3767 19.0061 20.7177 18.9406C21.08 18.871 21.4685 18.7189 21.8028 18.3961C22.1291 18.081 22.3266 17.6772 22.4479 17.2384C22.4569 17.2058 22.4642 17.1729 22.4699 17.1396L23.944 8.46865C24.2528 7.20993 23.2684 5.99987 21.9896 6H21.9894H4.74727L4.07666 2.45562L4.07608 2.4525C3.83133 1.12381 2.76159 8.49962e-05 1.33889 0H1.33883H1ZM5.12568 8L6.8227 16.9692H18.8178H18.8179C19.0686 16.9691 19.3257 16.9793 19.5406 16.9877L19.5413 16.9877C19.633 16.9913 19.7171 16.9947 19.7896 16.9967C20.0684 17.0047 20.2307 16.9976 20.3403 16.9766C20.3841 16.9681 20.4059 16.96 20.4151 16.9556C20.4247 16.9443 20.4639 16.8918 20.5077 16.7487L21.9794 8.09186C21.9842 8.06359 21.9902 8.03555 21.9974 8.0078C21.9941 8.00358 21.9908 8.00108 21.989 8H5.12568ZM20.416 16.9552C20.4195 16.9534 20.4208 16.9524 20.4205 16.9523C20.4204 16.9523 20.4199 16.9525 20.4191 16.953L20.416 16.9552ZM10.8666 22.4326C10.8666 23.2982 10.195 24 9.36658 24C8.53815 24 7.86658 23.2982 7.86658 22.4326C7.86658 21.567 8.53815 20.8653 9.36658 20.8653C10.195 20.8653 10.8666 21.567 10.8666 22.4326ZM18.0048 24C18.8332 24 19.5048 23.2982 19.5048 22.4326C19.5048 21.567 18.8332 20.8653 18.0048 20.8653C17.1763 20.8653 16.5048 21.567 16.5048 22.4326C16.5048 23.2982 17.1763 24 18.0048 24Z" fill="currentColor"></path></svg>${window.productCard.addToCart}</button>`
            }
          </div>
          <div style="width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    color: #858585;
    gap: 0.5rem;
    font-size: 0.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;" class="compare-button">
            <input type="checkbox" style="width:20px;height:20px;" class="compare-checkbox" data-product-id="8058529448157" id="compare-${id}-{{section.id}}" is="compare-button" product-handle="${handle}">
            <label class="compare-label" for="compare-${id}-{{section.id}}">Compare</label>
          </div>
  
  </div>
  </div>
    </li>
    <li class="grid-item-desktop">
      <div class="product-card-mini">
        <script type="application/json" product-handle="${handle}">
          {
            "id": ${id},
            "title": "${title}",
            "variant_id": "${variant_id}",
            "handle": "${handle}",
            "price": "${price}",
            "compare_at_price": "${compare_at_price}",
            "image": "${image || image2}",
            "url": "${window.Shopify.routes.root}products/${handle}"
          }
        </script>
        <div class="card-img">
          <a href="${
            window.Shopify.routes.root
          }products/${handle}" class="image-wrapper">
            <img class="irvine-lazy render-image" alt="${title}" src="${image}"/>
          </a>
          <add-to-cart class="add-to-cart" product-handle="${handle}">${
      window.productCard.addToCart
    }</add-to-cart>
        </div>
        <div class="card-info">
            <a class="card-price" href="${
              window.Shopify.routes.root
            }products/${handle}">
              <div class="card-price-container">
                <span class="current-price">
                ${
                  title.includes("WatchGuard") || title.includes("Xilica") || title.includes("AxxonSoft")
                    ? `Inquire for Price`
                    : currency +
                      String(CurrencyFormatted(Number(price).toFixed(2)))
                }
                </span>
                ${
                  title.includes("WatchGuard") || title.includes("Xilica") || title.includes("AxxonSoft")
                    ? ""
                    : compare_at_price > price
                    ? `<span class="old-price">${
                        currency +
                        String(
                          CurrencyFormatted(Number(compare_at_price).toFixed(2))
                        )
                      }</span>`
                    : ""
                }
              </div>
              ${
                title.includes("WatchGuard") || title.includes("Xilica") || title.includes("AxxonSoft")
                  ? ``
                  : compare_at_price > price
                  ? `
              <span class="discount-price">Save ${
                currency +
                String(
                  CurrencyFormatted(Number(compare_at_price - price).toFixed(2))
                )
              }</span>
            `
                  : ""
              }
            </a>
            <a class="card-title vertical-overflow" href="${
              window.Shopify.routes.root
            }products/${handle}">${title}</a>
            ${
              showReview
                ? `
              <a id="yotpo-pdp-stars" class="yotpo-pdp-stars" href="${
                window.Shopify.routes.root
              }products/${handle}#yotpo-app">
                <div class="yotpo-widget-instance" data-yotpo-instance-id="415303" data-yotpo-cart-product-id="" data-yotpo-product-id="${
                  id.split("|")[1]
                }" data-yotpo-section-id="index"></div>
              </a>`
                : ``
            }
            <span class="card-stock ${
              availabity ? "in-stock" : "out-of-stock"
            }">${
      availabity ? window.productCard.inStock : window.productCard.soldOut
    }</span>
            <a class="card-shipping us-only" href="${
              window.Shopify.routes.root
            }products/${handle}">${window.productCard.freeShipping}</a>
            <add-to-cart class="add-to-cart-mobile" product-handle="${handle}">${
      window.productCard.addToCart
    }</add-to-cart>
        </div>
    </li>
  `;
  };


  const generateMarkupForActiveFacets = () => {
    //get options.filters.all array and generate markup for active facets
    const activeFacets = options.filters.all.map((filter) => {
      if (filter.collections || filter.status || filter.collection_handles || filter.total_inventory) {
        return;
      }

      const type = Object.keys(filter)[0];
      if (window.location.pathname.includes("/vendors")) {
        if (type == "vendor") {
          return;
        }
      }

      const values = filter[type];

      if (type == "any") {
        priceActive = [];
        const anyIndex = options.filters.all.findIndex((filter) =>
          filter.hasOwnProperty("any")
        );
        options.filters.all[anyIndex].any.forEach((price) => {
          const from = price.price.from;

          const to = price.price.to;

          if (to) {
            priceActive.push(`
       <button class="facet-filter__remove-content" data-facet-type="price" data-facet-value="${
         from + "-" + to
       }"  data-facet-type="price"  >
                            <span class="facet-filter__remove">
                             <span>  ${
                               currency +
                               " " +
                               String(
                                 CurrencyFormatted(
                                   Number(currencyRate * from).toFixed(0)
                                 )
                               ) +
                               " - " +
                               currency +
                               " " +
                               String(
                                 CurrencyFormatted(
                                   Number(currencyRate * to).toFixed(0)
                                 )
                               )
                             }</span>
                             <span> x</span>
                            </span>
                            
                          </button>
        `);
          } else {
            priceActive.push(` <button class="facet-filter__remove-content" data-facet-type="price" data-facet-value="${
              from + "+"
            }"  data-facet-type="price"  >
                            <span class="facet-filter__remove">
                              <span>${
                                currency +
                                " " +
                                String(
                                  CurrencyFormatted(
                                    Number(currencyRate * from).toFixed(0)
                                  )
                                ) +
                                "+"
                              }</span>
                              <span> x</span>
                            </span>
                             
                          </button>`);
          }
        });
        return priceActive.join("");
      }
      if (type !== "any") {
        const markup = values.map((value) => {
          return `
       <button class="facet-filter__remove-content"  data-facet-type="${type}" data-facet-value='${value}' >
                            <span class="facet-filter__remove">
                             <span>${value}</span>
                             <span> x</span>
                            </span>
                            
                          </button>
        `;
        });
        return markup.join("");
      }
    });
    const q_within = options.query;
    if (q_within && window.location.pathname.includes("/collections"))
      activeFacets.push(` <button class="facet-filter__remove-content" data-facet-type="q_within" data-facet-value="${q_within}"  >
                            <span class="facet-filter__remove">
                              <span>Search Within: ${q_within}</span>
                              <span> x</span>
                            </span>

                          </button>`);

    return `
    <div style="color:black;" class="facet-container">
   
    <div class="facet-items-active">
    ${
      activeFacets.filter((item) => item !== undefined).length == 0
        ? ""
        : `
    <button class="facet-filter__remove-content" data-facet-type="all" data-facet-value="all" >
                            <span class="facet-filter__remove">
                              <span>Clear All</span>
                              <span> x</span>
                            </span>

                          </button>`
    }
    ${activeFacets.join("")}
    </div>
    </div>
    `;
  };

  // Global variable to check if it's a vendor path
  const isVendorPath = window.location.pathname.includes("/vendors");

  // Function to capitalize each word in a string
  const capitalizeEachWord = (str) => {
    const words = str.split(" ");
    const capitalizedWords = words.map((word) => {
      if (word.trim() === "") {
        return "";
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
    });

    const capitalizedString = capitalizedWords.join(" ");
    if (capitalizedString.includes("Usb")) {
      return capitalizedString.replace("Usb", "USB");
    }

    return capitalizedString;
  };

  const generateMarkUpForFacets = (_type, _values) => {
    const type = _type;

    if (isVendorPath && type === "vendor") {
      return;
    }

    let sum_count = 0;
    let counter = -1;
    const facetValues = _values.map((value) => {
      if (isVendorPath && type === "vendor") {
        return;
      }

      const name = value.key;
      const count = value.count;

      if (count === 0 || name === "" || name === "null") {
        return;
      }
      counter++;

      sum_count += count;

      let checkedFacetIndex;
      if (type !== "price") {
        checkedFacetIndex = options.filters.all.findIndex((filter) =>
          filter.hasOwnProperty(type)
        );
      } else {
        checkedFacetIndex = options.filters.all.findIndex((filter) =>
          filter.hasOwnProperty("any")
        );
      }

      if (type === "price") {
        const transformValue = (value) => {
          const [from, to] = value.key.split("-").map((val) =>
            val === "*" ? NaN : Number(val)
          );
          return {
            from,
            to,
            count: value.count,
          };
        };
      
        value = transformValue(value);
      }
      

      const isChecked =
        checkedFacetIndex !== -1 &&
        (type !== "price"
          ? options.filters.all[checkedFacetIndex][type].includes(name)
          : options.filters.all[checkedFacetIndex].any.some(
            (filter) =>
              filter.price.from === value.from &&
              (isNaN(filter.price.to) || filter.price.to === value.to)
          ));


      return `
      <div class="facet-item label-item ${counter >= 5 ? "hide-item" : ""}">
        <input 
          type="checkbox" 
          aria-label="${
            name
              ? name
              : value.to
              ? `${value.from}-${value.to}`
              : `${value.from}`
          }" 
          ${isChecked ? "checked" : ""}
          data-facet-type="${type}" 
          data-facet-value="${
            name
              ? name
              : value.to
              ? `${value.from}-${value.to}`
              : `${value.from}`
          }" 
          id="${
            name
              ? name
              : value.to
              ? `${value.from}-${value.to}`
              : `${value.from}`
          }" 
          name="${
            name
              ? name
              : value.to
              ? `${value.from}-${value.to}`
              : `${value.from}`
          }" 
          value="${
            name
              ? name
              : value.to
              ? `${value.from}-${value.to}`
              : `${value.from}`
          }" 
          class="facet-checkbox"
        >
        <label for="${
          name ? name : value.to ? `${value.from}-${value.to}` : `${value.from}`
        }" class="facet-label label-group">
          <span class="facet-label-text label-selector">
          ${
            name && type === "price"
              ? `${currency}${CurrencyFormatted(
                  Number(currencyRate * value.from).toFixed(0)
                )} - ${isNaN(value.to) ? "*" : `${currency}${CurrencyFormatted(
                    Number(currencyRate * value.to).toFixed(0)
                  )}`}`
              : name
              ? name
              : value.to
              ? `${currency}${CurrencyFormatted(
                  Number(currencyRate * value.from).toFixed(0)
                )} - ${isNaN(value.to) ? "*" : `${currency}${CurrencyFormatted(
                    Number(currencyRate * value.to).toFixed(0)
                  )}`}`
              : `${currency}${CurrencyFormatted(
                  Number(currencyRate * value.from).toFixed(0)
                )}+`
          }          
          </span>
          <span class="facet-label-count label-selector">(${count})</span>
        </label>
      </div>
    `;
    });

    if (type === "price") {

      return `
      
        ${`<details data-for="${type}" open  class="facet-container facets__div" style="position: relative;">
            
                <summary>
                  <h3>${renderFacetName(type)}</h3>
                  <div class="summary-chevron-down">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-down"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>
                </summary>
                <div class="summary-chevron-down">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-chevron-down"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
                
               
    <div class="facet-items">
    <div
        data-lng="${facetValues.length}"
        data-sum="${
          type === "price" || type === "vendor" || type === "product_type"
            ? 99999999
            : sum_count
        }"
        data-for="${type}"
        class="facet-container facets__div"
      >
        
        <div data-sum="99999" id="Details-4-template--15804140093645__main" class="js-filter facets__div " >
          <div id="Facet-4-template--15804140093645__main">
            <price-range class="price-range-selector filter-price__container">
              <div class="filter-price__container-number">
                <div class="field field-input">
                  <input name="min-price" data-facet-type="price" id="min-price" value="${minPrice}" type="number" min="0" >
                  <label class="label-selector label-selector-price" for="min-price">${currency}</label>
                </div>
                <label class="label-selector" for="max-price">To</label>
                <div class="field field-input">
                  <input name="max-price" id="max-price" type="number" value="${maxPrice}" min="0" min="${1}" >
                  <span class="label-selector label-selector-price">${currency}</span>
                </div>
              </div>
            </price-range>
          </div>
        </div>
        <div style="margin-right:0;margin-left:0;" class="facet-items">
    
     ${facetValues.join("")}
     <div class="facet-items__show-more">
     ${
       counter >= 5
         ? `<button type="button" class ="show-more">
     
    View More
    <span class="view-more__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-down"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
    </button>`
         : ""
     }
    </div>
    </div>
    </div>
    
               
               
                
              </details>
    
    `}
      </div>`;
    }
  
    return `
    <details data-lng="${facetValues.length}" data-sum="${
      type == "price" || type == "vendor" || type == "product_type"
        ? 99999999
        : sum_count
    }"  ${
      options.filters.all.find((item) => Object.keys(item)[0] == type) ||
      type == "price" ||
      type == "vendor" ||
      type == "product_type" ||
      type == "condition"
        ? "open"
        : ""
    }  data-sum="${
      type == "price" || type == "vendor" || type == "product_type"
        ? 99999999
        : sum_count
    }" data-for="${type}"  class="facet-container facets__div" style="position: relative;">
                <summary>
                  <h3>${renderFacetName(type)}</h3>
                  <div class="summary-chevron-down">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-down"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>
                </summary>
                <div class="summary-chevron-down">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-chevron-down"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
               
    <div class="facet-items">
    <input type="text" class="facet-search" placeholder="${searchPlaceholderTranslations[language] || 'Search Filter'}" />
    

     ${facetValues.join("")}
     <div class="facet-items__show-more">
     ${
       counter >= 5
         ? `<button type="button" class ="show-more">
     
    View More
    <span class="view-more__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-down"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
    </button>`
         : ""
     }
    </div>
    </div>
    
               
               
                
              </details>
    
    `;
  };

  // You can use this function as before

  const handleData = (results, facets, productCount) => {
    const facetContainer = document.getElementById("facetsContent");
    const activeContainer = document.getElementById("elastic-active");
    const productCountBar = document.getElementById("ProductCount");
    const mobileProductCountBar = document.querySelector(".mobile-count");

    facetContainer.innerHTML = "";
    activeContainer.innerHTML = "";

    const totalCount = productCount.total_document;
    const resultCount = productCount.total_results;

    if (totalCount !== productCount.total_results && resultCount !== 0) {
      const translations = productCountTranslations[language] || productCountTranslations.en;
      const message = `${resultCount} ${translations.of} ${totalCount} ${translations.products}`;
      productCountBar.innerHTML = message;
      mobileProductCountBar.innerHTML = message;
    } else if (resultCount === 0) {
      const noProductsMessage = (productCountTranslations[language] || productCountTranslations.en).noProductsFound;
      productCountBar.innerHTML = noProductsMessage;
      mobileProductCountBar.innerHTML = noProductsMessage;
    } else {
      const translations = productCountTranslations[language] || productCountTranslations.en;
      const message = `${totalCount} ${translations.products}`;
      productCountBar.innerHTML = message;
      mobileProductCountBar.innerHTML = message;
    }

    const generalMarkup = results.map((result, index) => {
      /* Removed translations part for now
      if (result.data.translations && window.locale.iso_code != "en") {
        const translationData = JSON.parse(result.data.translations.raw[0]);
        if (translationData[window.locale.iso_code]) {
          result.data.title.raw = translationData[window.locale.iso_code].title;
          result.data.description.raw =
            translationData[window.locale.iso_code].description;
        }
      }*/

      const {
        title,
        image,
        price,
        id,
        handle,
        description,
        variant_id,
        compare_at_price,
        vendor,
        total_inventory,
        second_image,
        yotpo_reviews_count,
      } = result;
      const _price = Number(price * currencyRate);
      const _compare_at_price = compare_at_price
        ? Number(compare_at_price * currencyRate)
        : Number(0);
      const _availabity = total_inventory ? total_inventory > 0 : false;
      const _image2 = second_image ? second_image : null;

      const first = index === 0;
      const count = total_inventory ? total_inventory : 0;

      let markup = generateMarkUpForProduct(
        title,
        image ? image : null,
        _price,
        id ? String(id) : null,
        handle,
        description ? description : null,
        variant_id,
        _compare_at_price,
        vendor,
        _availabity,
        _image2,
        first,
        count,
        yotpo_reviews_count
      );
      return markup ? markup.replace("<tag_bug_fix>", "</s" + "cript>") : null;
    });

    const facetsTemp = Object.entries(facets);
    const filteredFacets = facetsTemp.map(([_, data]) => data);

    const totalFacetsMarkup =  filteredFacets
      .filter(facet => facet.values?.length > 0)
      .map(facet => generateMarkUpForFacets(facet.name, facet.values))
      .sort((a, b) => {
        const numA = parseInt(a.split('data-sum="')[1].split('"')[0]);
        const numB = parseInt(b.split('data-sum="')[1].split('"')[0]);
        return numB - numA;
      });
    facetContainer.insertAdjacentHTML("beforeend", totalFacetsMarkup.join(""));

    document.querySelectorAll(".show-more").forEach((button) => {
      button.addEventListener("click", (e) => {
        const parent = e.target.closest(".facet-items");
        parent.querySelectorAll(".hide-item").forEach((item) => {
          item.classList.toggle("show-item");
        });
        button.querySelector(".view-more__icon").classList.toggle("rotate180");
        if (
          button
            .querySelector(".view-more__icon")
            .classList.contains("rotate180")
        ) {
          button.childNodes[0].textContent = "View Less";
        } else {
          button.childNodes[0].textContent = "View More";
        }
      });
    });
    const facetSearch = document.querySelectorAll(".facet-search");
    facetSearch.forEach((search) => {
      search.addEventListener("input", (e) => {
        //filter the closset facet container and search exact value the data-for attribute and display hidden other facets

        const facetContainer = e.target.closest(".facet-container");
        const viewMoreButton = facetContainer.querySelector(".show-more");

        const facetItems = facetContainer.querySelectorAll(".facet-item");
        if (e.target.value.trim() == "") {
          if (viewMoreButton) {
            viewMoreButton.style.display = "flex";
          }
          viewMoreButton
            .querySelector(".view-more__icon")
            .classList.remove("rotate180");
          if (
            viewMoreButton
              .querySelector(".view-more__icon")
              .classList.contains("rotate180")
          ) {
            viewMoreButton.childNodes[0].textContent = "View Less";
          } else {
            viewMoreButton.childNodes[0].textContent = "View More";
          }
          facetItems.forEach((item, index) => {
            item.classList.remove("hide-item");
            item.classList.remove("show-item");

            if (index > 5) {
              item.classList.add("hide-item");
            }
          });
          return;
        }
        if (viewMoreButton) {
          viewMoreButton.style.display = "none";
        }
        facetItems.forEach((item) => {
          item.classList.remove("hide-item");
        });
        const facetItemsArray = Array.from(facetItems);
        const facetItemsArrayFiltered = facetItemsArray.filter((item) => {
          const facetValue = item
            .querySelector(".facet-label-text")
            .textContent.trim()
            .toLowerCase();
          return facetValue.includes(e.target.value.trim().toLowerCase());
        });
        facetItemsArray.forEach((item) => {
          item.classList.remove("show-item");
          item.classList.add("hide-item");
        });
        facetItemsArrayFiltered.forEach((item) => {
          item.classList.remove("hide-item");
          item.classList.add("show-item");
        });
      });
    });

    activeContainer.innerHTML = generateMarkupForActiveFacets();

    const productGrid = document.getElementById("product-grid");
    productGrid.innerHTML = generalMarkup.filter((markup) => !!markup).join("");

    removeFreeShipping();

    var productGridWrapper = document.querySelector(".grid-wrapper");

    var filterModalBtn = document.querySelector(".filters-modal-btn");
    var filterModalOverlay = document.querySelector(
      ".modal-overlay-collection"
    );

    var filterModalCloseBtn = document.querySelector(".collection-modal-close");
    var filterModal = document.querySelector(".facets-container");
    var listBtn = document.querySelector("#list-btn");
    var gridBtn = document.querySelector("#grid-btn");
    listBtn.addEventListener("click", (e) => {
      e.preventDefault();
      gridBtn.style.opacity = 0.4;
      listBtn.style.opacity = 1;
      productGridWrapper.classList.add("list-view");
      listViewStat = true;
      const items = document.querySelectorAll(".list-item-desktop");
      const gridItems = document.querySelectorAll(".grid-item-desktop");
      gridItems.forEach((item) => {
        item.classList.add("hide-item");
      });
      items.forEach((item) => {
        item.classList.remove("hide-item");
      });
    });
    gridBtn.addEventListener("click", (e) => {
      e.preventDefault();
      listBtn.style.opacity = 0.4;
      gridBtn.style.opacity = 1;
      productGridWrapper.classList.remove("list-view");
      listViewStat = false;
      const items = document.querySelectorAll(".grid-item-desktop");
      const listItems = document.querySelectorAll(".list-item-desktop");
      listItems.forEach((item) => {
        item.classList.add("hide-item");
      });
      items.forEach((item) => {
        item.classList.remove("hide-item");
      });
    });
    filterModalBtn.addEventListener("click", (e) => {
      e.preventDefault();
      filterModal.style.display = "flex";
      filterModalOverlay.style.display = "block";
    });
    filterModalCloseBtn.addEventListener("click", (e) => {
      e.preventDefault();
      filterModal.style.display = "none";
      filterModalOverlay.style.display = "none";
    });
    if (listViewStat) {
      productGridWrapper.classList.add("list-view");

      const items = document.querySelectorAll(".grid-item-desktop");
      const listItems = document.querySelectorAll(".list-item-desktop");

      listItems.forEach((item) => {
        item.classList.remove("hide-item");
      });
      items.forEach((item) => {
        item.classList.add("hide-item");
      });
    }
  };

  const fetchFacets = async (options, page = 1) => {
    const skeleton = document.querySelector(".card-skeleton");
    const facetSkeleton = document.getElementById("facetsContent-skeleton");
    const facetContent = document.getElementById("facetsContent");
    

    if (!facetContent || !facetSkeleton || !skeleton) {
      return;
    }

    facetSkeleton.style.display = "block";
    skeleton.style.display = "block";

    const productGrid = document.getElementById("product-grid");
    productGrid.style.display = "none";
    facetContent.style.display = "none";

    options.page.current = page;
    const pageSize = 42;

    const fetchProductCount = async (options) => { 
          const queryText = options.query || "";
          const facets = options.facets;
          const filters = options.filters;
          const sort = options.sort;
          const language = segments[1].length > 2 ? segments[1].substring(0, 2) : segments[1];

          const functionUrl = "https://us-west1-fetchsome.cloudfunctions.net/function-searcai";
          try {
            const response = await fetch(functionUrl, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  queryText: queryText,
                  filters: filters,
                  facets: facets,
                  sort: sort,
                  page: options.page.current,
                  pageSize: pageSize,
                  language: language,
              }),
            });
          const data = await response.json();
          const transformedData = Array.isArray(data.hits?.hits) 
          ? data.hits.hits.map(hit => hit._source) 
          : Array.isArray(data.hits) 
              ? data.hits.map(hit => hit._source) 
              : [];

          const transformedFacets = Object.keys(data.facets.filtered_facets).map(facetName => {
                const buckets = data.facets.filtered_facets[facetName].buckets || [];
                return {
                  name: facetName,
                  values: buckets.map(bucket => ({
                    key: bucket.key,
                    count: bucket.doc_count,
                  })),
                };
          });
                    
          const totalResults = data.totalHits > total_res
                                ? total_res
                                : data.totalHits;

          const totalPages = Math.ceil(totalResults / pageSize);

          const productCount = {
            total_results: totalResults,
            total_pages: totalPages
          };
          

          return { data: transformedData, productCount, facets: transformedFacets };
        } catch (error) {
          console.error("Error fetching product count:", error);
          return { data: null, productCount: { total_results: 0 } };
        }
      };
  
  
      try {
      const { data, productCount, facets } = await fetchProductCount(options);

      if (productCount.total_results === 0) {
        const pagination = document.getElementById("pagination");
        pagination.style.display = "none";

        if (window.location.pathname === "/search") {
          const gridTop = document.querySelector(".grid-top__items-right");
          const gridTopWrapper = document.querySelector(".grid-top__items");
          gridTopWrapper.style.alignItems = "center";
          gridTopWrapper.style.backgroundColor = "transparent";
          gridTopWrapper.style.flexDirection = "column";
          const homeBtn = document.createElement("a");
          homeBtn.href = "./";
          homeBtn.classList.add("back-home");
          homeBtn.textContent = "Back to Home";

          gridTopWrapper.appendChild(homeBtn);

          gridTop.innerHTML =
            '<p style="text-align:center;" class="collection-title">No Products Found</p>';
          const facetWrapper = document.querySelector(".facets-container");
          facetWrapper.style.display = "none";
          const gridWrapper = document.querySelector(".grid-wrapper");
          gridWrapper.style.justifyContent = "center";
          const collectionTitle =
            document.querySelectorAll(".collection-title");
          collectionTitle.forEach(
            (item) => (item.style.visibility = "visible")
          );
        } else {
          const facetSortForm = document.getElementById("FacetSortForm");
          facetSortForm.style.display = "none";
        }

        // Clear the loading indicators and return since there are no products
        skeleton.style.display = "none";
        facetSkeleton.style.display = "none";
        facetContent.style.display = "block";
        productGrid.style.display = "grid";
        return;
      }

      // Assuming 'total_res' is a variable you meant to use here.
      productCount.total_document = total_res;
      const totalPages = Math.ceil(productCount.total_results / pageSize);
      const currentPage = options.page.current;

      init(totalPages, currentPage, 3);

      handleData(data, facets, productCount);
      yotpoWidgetsContainer.initWidgets();
    } catch (error) {
      console.log(`error: ${error}`);
    } finally {
      // Clear the loading indicators after fetching data
      skeleton.style.display = "none";
      facetSkeleton.style.display = "none";
      facetContent.style.display = "block";
      productGrid.style.display = "grid";
    }
  };

  var Pagination = {
    code: "",

    // --------------------
    // Utility
    // --------------------

    // converting initialize data
    Extend: function (data) {
      data = data || {};
      Pagination.size = data.size >= 100 ? 100 : data.size;
      Pagination.page = data.page || 1;
      Pagination.step = data.step || 3;
    },

    // add pages by number (from [s] to [f])
    Add: function (s, f) {
      for (var i = s; i < f; i++) {
        Pagination.code += "<a>" + i + "</a>";
      }
    },

    // add last page with separator
    Last: function () {
      Pagination.code += "<i>...</i><a>" + Pagination.size + "</a>";
    },

    // add first page with separator
    First: function () {
      Pagination.code += "<a>1</a><i>...</i>";
    },

    // --------------------
    // Handlers
    // --------------------

    // change page
    Click: function () {
      Pagination.page = +this.innerHTML;

      if (!this.classList.contains("current")) {
        fetchFacets(options, Pagination.page);
        updateUrl();
      }
      Pagination.Start();
    },

    // previous page
    Prev: function () {
      Pagination.page--;
      if (Pagination.page < 1) {
        Pagination.page = 1;
      }

      fetchFacets(options, Pagination.page);
      updateUrl();

      Pagination.Start();
    },

    // next page
    Next: function () {
      Pagination.page++;
      if (Pagination.page > Pagination.size) {
        Pagination.page = Pagination.size;
      }

      fetchFacets(options, Pagination.page);
      updateUrl();

      Pagination.Start();
    },

    // --------------------
    // Script
    // --------------------

    // binding pages
    Bind: function () {
      var a = Pagination.e.getElementsByTagName("a");
      for (var i = 0; i < a.length; i++) {
        if (+a[i].innerHTML === Pagination.page) a[i].className = "current";
        a[i].addEventListener("click", Pagination.Click, false);
      }
    },

    // write pagination
    Finish: function () {
      Pagination.e.innerHTML = Pagination.code;
      Pagination.code = "";
      Pagination.Bind();
    },

    // find pagination type
    Start: function () {
      if (Pagination.size < Pagination.step * 2 + 6) {
        Pagination.Add(1, Pagination.size + 1);
      } else if (Pagination.page < Pagination.step * 2 + 1) {
        Pagination.Add(1, Pagination.step * 2 + 4);
        Pagination.Last();
      } else if (Pagination.page > Pagination.size - Pagination.step * 2) {
        Pagination.First();
        Pagination.Add(
          Pagination.size - Pagination.step * 2 - 2,
          Pagination.size + 1
        );
      } else {
        Pagination.First();
        Pagination.Add(
          Pagination.page - Pagination.step,
          Pagination.page + Pagination.step + 1
        );
        Pagination.Last();
      }
      Pagination.Finish();
    },

    // --------------------
    // Initialization
    // --------------------

    // binding buttons
    Buttons: function (e) {
      var nav = e.getElementsByTagName("a");
      nav[0].addEventListener("click", Pagination.Prev, false);
      nav[1].addEventListener("click", Pagination.Next, false);
    },

    // create skeleton
    Create: function (e) {
      var html = [
        `<a>
          <svg style="transform: rotate(90deg); width: 12px; height: 12px;" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" />
            <path d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" />
          </svg>
        </a>`, // previous button
        "<span></span>", // pagination container
        `<a>
          <svg style="transform: rotate(-90deg); width: 12px; height: 12px;" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" />
            <path d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" />
          </svg>
        </a>`, // next button
      ];

      e.innerHTML = html.join("");
      Pagination.e = e.getElementsByTagName("span")[0];
      Pagination.Buttons(e);
    },

    // init
    Init: function (e, data) {
      if (data.size !== 1) {
        Pagination.Extend(data);
        Pagination.Create(e);
        Pagination.Start();
      }
    },
  };

  /* * * * * * * * * * * * * * * * *
   * Initialization
   * * * * * * * * * * * * * * * * */

  var init = function (size, page, step) {
    document.getElementById("pagination").innerHTML = "";
    Pagination.Init(document.getElementById("pagination"), {
      size: size ?? 48, // pages size
      page: page ?? 1, // selected page
      step: step ?? 3, // pages before and after current
    });
  };

  const addListener = async () => {
    const facetForm = document.getElementById("FacetFiltersForm");
    const sortForm = document.getElementById("SortBy");

    if (sortForm) {
      sortForm.addEventListener("change", (e) => {
        if (e.target.value == "relevance") {
          //options.sort = [{ sort_number: "asc" }];
          options.sort = []
        } else {
          const sortValue = e.target.value.split("-")[0];
          const sortDirection = e.target.value.split("-")[1];
          options.sort = [{ [sortValue]: sortDirection }];
        }
        updateUrl();

        fetchFacets(options);
      });
    }

    window.addEventListener("popstate", async (e) => {
      options.filters.all = [];
      options.filters.any = [];

      if (window.location.pathname.includes("/search")) {
        options.search_fields = {
          title: { weight: 10 },
          vendor: { weight: 10 },
        };
      }
      if (
        window.location.pathname.includes("/collections") &&
        !window.location.pathname.includes("/vendors") &&
        !window.location.pathname.includes("/search")
      ) {
        const collection = document
          .getElementById("page-collections")
          .getAttribute("data-collection");
        
        const collectionHandle = document
          .getElementById("page-collections")
          .getAttribute("data-handle");
          
        options.filters.all = [
          { collection_handles: `${collectionHandle}` },
        ];
        if (
          window.location.pathname.includes("/vendors") &&
          !window.location.pathname.includes("/search")
        ) {
          options.filters.all = [{ vendor: [collection] }];
        }
      }
      options.filters.all.push({ status: "ACTIVE" });

      await getInitialUrlCollection();
    });

    if (facetForm) {
      facetForm.addEventListener("submit", (e) => {
        e.preventDefault();
        const submitter = e.submitter;

        const facetValue = submitter.getAttribute("data-facet-value");
        const facetType = submitter.getAttribute("data-facet-type");
        //if data facet value is all remove all filters from options.filters.all array except collecitons filter if there is and fetch data again with empty options.filters.all
        if (facetType == "q_within") {
          options.query = "";
          const search_within = document.getElementById("search_within");
          if (search_within) {
            search_within.value = "";
          }
          fetchFacets(options);
          updateUrl();
          return;
        }
        if (facetValue == "all") {
          if (window.location.pathname.includes("/collections")) {
            options.query = "";
          }
          options.filters.all = [];
          if (window.location.pathname.includes("/collections")) {
            const collection = document
              .getElementById("page-collections")
              .getAttribute("data-collection");
            const collectionHandle = document
              .getElementById("page-collections")
              .getAttribute("data-handle");

            options.filters.all = [
              { collection_handles: `${collectionHandle}` },
            ];
            if (
              window.location.pathname.includes("/vendors") &&
              !window.location.pathname.includes("/search")
            ) {
              options.filters.all = [{ vendor: [collection] }];
            }
          }
          options.filters.all.push({ status: "ACTIVE" });
          fetchFacets(options);
          updateUrl();
          return;
        }
        let index;
        if (submitter.getAttribute("data-facet-type") == "price") {
          index = options.filters.all.findIndex((filter) =>
            filter.hasOwnProperty("any")
          );
        } else {
          index = options.filters.all.findIndex((filter) =>
            filter.hasOwnProperty(submitter.getAttribute("data-facet-type"))
          );
        }
        if (index !== -1) {
          const filterType = submitter.getAttribute("data-facet-type");
          const filterValue = facetValue;
          let filterValueIndex;
          if (filterType == "price") {
            filterValueIndex = options.filters.all[index].any.findIndex(
              (filter) => {
                return filter.price.to
                  ? filter.price.from == facetValue.split("-")[0] &&
                      filter.price.to == facetValue.split("-")[1]
                  : filter.price.from == facetValue.split("-")[0].slice(0, -1);
              }
            );
          } else {
            filterValueIndex =
              options.filters.all[index][filterType].indexOf(filterValue);
          }

          if (filterValueIndex !== -1) {
            if (filterType == "price") {
              options.filters.all[index].any.splice(filterValueIndex, 1);
            } else {
              options.filters.all[index][filterType].splice(
                filterValueIndex,
                1
              );
            }
          }

          if (filterType != "price") {
            if (options.filters.all[index][filterType].length === 0) {
              options.filters.all.splice(index, 1);
            }
          }
          if (filterType == "price") {
            const anyIndex = options.filters.all.findIndex((filter) =>
              filter.hasOwnProperty("any")
            );
            if (options.filters.all[anyIndex].any.length == 0) {
              options.filters.all.splice(anyIndex, 1);
            }
          }
        } else {
          const filterType = submitter.getAttribute("data-facet-type");
          const filterValue = facetValue;
          const filterValueIndex =
            options.filters.all[index][filterType].indexOf(filterValue);
          if (filterValueIndex !== -1) {
            options.filters.all[index][filterType].splice(filterValueIndex, 1);
          }
          if (options.filters.all[index][filterType].length === 0) {
            options.filters.all.splice(index, 1);
          }
        }

        fetchFacets(options);
        updateUrl();
      });

      function inputDebounced(e) {
        const facetValue = e.target.getAttribute("data-facet-value");
        const facetType = e.target.getAttribute("data-facet-type");

        if (e.target.type == "number") {
          return;
        }

        if (e.target.checked) {
          let index;
          if (facetType == "price") {
            index = options.filters.all.findIndex((filter) =>
              filter.hasOwnProperty("any")
            );
          } else {
            index = options.filters.all.findIndex((filter) =>
              filter.hasOwnProperty(e.target.getAttribute("data-facet-type"))
            );
          }
          if (index !== -1) {
            const filterType = e.target.getAttribute("data-facet-type");
            const filterValue = facetValue;
            if (filterType == "price") {
              const from = filterValue.split("-")[0];
              const to = filterValue.split("-")[1];
              const anyIndex = options.filters.all.findIndex((filter) =>
                filter.hasOwnProperty("any")
              );
              if (anyIndex == -1) {
                if (to) {
                  options.filters.all.push({
                    any: [
                      {
                        price: {
                          from: Number(from),
                          to: Number(to),
                        },
                      },
                    ],
                  });
                } else {
                  options.filters.all.push({
                    any: [
                      {
                        price: {
                          from: Number(filterValue),
                        },
                      },
                    ],
                  });
                }
              } else {
                if (to) {
                  options.filters.all[anyIndex].any.push({
                    price: {
                      from: Number(from),
                      to: Number(to),
                    },
                  });
                } else {
                  options.filters.all[anyIndex].any.push({
                    price: {
                      from: Number(filterValue),
                    },
                  });
                }
              }
            } else {
              options.filters.all[index][filterType].push(filterValue);
            }
          } else {
            const filterType = e.target.getAttribute("data-facet-type");

            if (filterType == "price") {
              const filterType = e.target.getAttribute("data-facet-type");
              const filterValue = facetValue;
              const from = filterValue.split("-")[0];
              const to = filterValue.split("-")[1];
              if (to) {
                options.filters.all.push({
                  any: [
                    {
                      price: {
                        from: Number(from),
                        to: Number(to),
                      },
                    },
                  ],
                });
              } else {
                options.filters.all.push({
                  any: [
                    {
                      price: {
                        from: Number(filterValue),
                      },
                    },
                  ],
                });
              }
            } else {
              const filterType = e.target.getAttribute("data-facet-type");
              const filterValue = facetValue;
              options.filters.all.push({ [filterType]: [filterValue] });
            }
          }
        } else {
          // remove filter from options.filters.all array if unchecked and fetch data again with new options.
          // if options.filters.all is empty fetch data with empty options.filters.all
          let index;
          if (facetType == "price") {
            index = options.filters.all.findIndex((filter) =>
              filter.hasOwnProperty("any")
            );
          } else {
            index = options.filters.all.findIndex((filter) =>
              filter.hasOwnProperty(e.target.getAttribute("data-facet-type"))
            );
          }
          if (index !== -1) {
            const filterType = e.target.getAttribute("data-facet-type");
            const filterValue = facetValue;
            let filterValueIndex;
            if (filterType == "price") {
              filterValueIndex = options.filters.all[index].any.findIndex(
                (filter) => {
                  return filter.price.to
                    ? filter.price.from == facetValue.split("-")[0] &&
                        filter.price.to == facetValue.split("-")[1]
                    : filter.price.from == facetValue.split("-")[0];
                }
              );
            } else {
              filterValueIndex =
                options.filters.all[index][filterType].indexOf(filterValue);
            }

            if (filterValueIndex !== -1) {
              if (filterType == "price") {
                options.filters.all[index].any.splice(filterValueIndex, 1);
              } else {
                options.filters.all[index][filterType].splice(
                  filterValueIndex,
                  1
                );
              }
            }
            if (filterType != "price") {
              if (options.filters.all[index][filterType].length === 0) {
                options.filters.all.splice(index, 1);
              }
            }
            if (filterType == "price") {
              const anyIndex = options.filters.all.findIndex((filter) =>
                filter.hasOwnProperty("any")
              );
              if (options.filters.all[anyIndex].any.length == 0) {
                options.filters.all.splice(anyIndex, 1);
              }
            }
          } else {
            const filterType = e.target.getAttribute("data-facet-type");
            const filterValue = facetValue;
            const filterValueIndex =
              options.filters.all[index][filterType].indexOf(filterValue);
            if (filterValueIndex !== -1) {
              options.filters.all[index][filterType].splice(
                filterValueIndex,
                1
              );
            }
            if (options.filters.all[index][filterType].length === 0) {
              options.filters.all.splice(index, 1);
            }
          }
        }
        updateUrl();
        fetchFacets(options);
      }
      function pressEnter(e) {
        const min = document.getElementById("min-price");
        const max = document.getElementById("max-price");
        maxPrice = max.value;
        minPrice = min.value;
        const anyIndex = options.filters.all.findIndex((filter) =>
          filter.hasOwnProperty("any")
        );
        if (anyIndex !== -1) {
          options.filters.all[anyIndex].any = [];
          if (min.value && max.value) {
            options.filters.all[anyIndex].any.push({
              price: {
                from: Number(min.value),
                to: Number(max.value),
              },
            });
          }
          if (max.value && !min.value) {
            options.filters.all[anyIndex].any.push({
              price: {
                to: Number(max.value),
                from: 0,
              },
            });
          }
          if (min.value && !max.value) {
            options.filters.all[anyIndex].any.push({
              price: {
                from: Number(min.value),
              },
            });
          }
        } else {
          if (min.value && max.value) {
            options.filters.all.push({
              any: [
                {
                  price: {
                    from: Number(min.value),
                    to: Number(max.value),
                  },
                },
              ],
            });
          }
          if (max.value && !min.value) {
            options.filters.all.push({
              any: [
                {
                  price: {
                    to: Number(max.value),
                  },
                },
              ],
            });
          }
          if (min.value && !max.value) {
            options.filters.all.push({
              any: [
                {
                  price: {
                    from: Number(min.value),
                  },
                },
              ],
            });
          }
        }
        updateUrl();
        fetchFacets(options);
      }
      const debouncedFunc = debounceElastic(inputDebounced, 300);
      facetForm.addEventListener(
        "input",
        (e) => !e.target.classList.contains("facet-search") && debouncedFunc(e)
      );
      facetForm.addEventListener("keydown", (e) => {
        if (e.key == "Enter") {
          pressEnter(e);
        }
      });
    }
  };

  await getInitialUrlCollection();

  addListener();
};
InfinityElastic();